import {
  faCartArrowDown,
  faEye,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  addDays,
  addMonths,
  format,
  getDate,
  getDay,
  parse,
  parseISO,
  set,
  setDate,
} from 'date-fns'
import html2canvas from 'html2canvas'
import jsPDF, { ShadingPattern } from 'jspdf'
import { Asterisk, CheckCircle, Clock, XCircle } from 'lucide-react'
import moment from 'moment'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import {
  Alert,
  Button,
  Col,
  Form,
  InputGroup,
  Modal,
  OverlayTrigger,
  Row,
  Spinner,
  Table,
  ToastBody,
  Tooltip,
} from 'react-bootstrap'
import {
  CheckCircleFill,
  CloudArrowDownFill,
  CloudArrowUp,
  CloudArrowUpFill,
  Files,
  Paperclip,
  PencilFill,
  PlusCircleFill,
  TrashFill,
  XCircleFill,
} from 'react-bootstrap-icons'
import { FaBarcode, FaShare, FaWhatsapp } from 'react-icons/fa'
import {
  default as InputMask,
  default as ReactInputMask,
} from 'react-input-mask'
import { NumberFormat } from 'react-number-format'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import swal from 'sweetalert'
import Swal from 'sweetalert2'
import { v4 as uuidv4 } from 'uuid'
import * as XLSX from 'xlsx'
import kangu from '../../assets/kangu.png'
import AutocompleteProdutoMatch from '../../components/auto-complete-match-produto/complete-match.jsx'
import AutocompleteClienteNode from '../../components/autocomplete-cliente/autocomplete-clientenode.jsx'
import { CustomButton } from '../../components/CustomButton/index.jsx'
import Navbar from '../../components/navbar/navbar.jsx'
import api from '../../services/api.js'
import apinode from '../../services/apinode.js'
import PessoasService from '../../services/database/PessoasService/index.js'
import { adaptValue } from '../../utils/adaptValue.js'
import { formatDate as formatDateUtils } from '../../utils/formatDate.js'
import { formatPrice } from '../../utils/formatPrice.js'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'
import '../pedido-editar/pedido-editar.css'
import CalcularParcelas from './calculator.jsx'
import PDFExtractorModal from './importarPdf'
import clientesPDF from './report.jsx'
import TrackModal from './trackmodal.jsx' // Importe o componente TrackModal

import axios from 'axios'
import DatePicker from 'react-datepicker'
import { FaSpinner } from 'react-icons/fa' // FaSpinner é o ícone de carregamento
import { SiMercadopago } from 'react-icons/si'
import { v4 } from 'uuid'
import { Ask } from '../../components/Ask/index.jsx'
import { ContentLoading } from '../../components/ContentLoading/index.js'
import { CustomInputDate } from '../../components/CustomInputDate/index.jsx'
import { CustomPriceInput } from '../../components/CustomPriceInput/index.jsx'
import { CustomSpinner } from '../../components/CustomSpinner/index.jsx'
import { useCommand } from '../../hooks/useCommand/index.js'
import OrderFileService from '../../services/database/OrderFileService/index.js'
import PedidosService from '../../services/database/PedidosService/index.js'
import { adaptToDatabase } from '../../utils/adaptToDatabase.js'
import ModernOrdersNavbar from './buttons'
import { reportOrderNoWMS } from './reportOrderNoWMS.jsx'
import { CaretCircleDown, CaretCircleUp } from 'phosphor-react'

function PedidoMK() {
  const [textoDigitado, setTextoDigitado] = useState('')
  const [estaBuscando, setEstaBuscando] = useState(true)
  const [dt_pedido, setDtPedido] = useState('')
  const [id_cond_pagto, setIdCondPagto] = useState(0)
  const [id_nfe, setIdnfe] = useState(null)
  const [dt_entrega, setDtEntrega] = useState('')
  const [obs, setObs] = useState('')
  const [produtos, setProdutos] = useState([])
  const [vl_total, setVlTotal] = useState(0)
  const [msg, setMsg] = useState('')
  const [desconto, setDesconto] = useState(0)
  const [vendedor, setVendedor] = useState('')
  const [indicacaoVenda, setIndicacaoVenda] = useState('')
  const [prestadorSelecionado, setPrestadorSelecionado] = useState('')
  const [lista_produtos, setListaProdutos] = useState([])
  const [lista_clientes, setListaClientes] = useState([])
  const [cond_pagtos, setCondPagtos] = useState([])
  const [id_cliente, setIdCliente] = useState('')
  const [nomeCliente, setNomeCliente] = useState('')
  const [cliente, setCliente] = useState('')
  const [cpf, setCpf] = useState('')
  const [dadospedido, setDadosPedido] = useState('')
  const [vendedores, setVendedores] = useState([])
  const [parceiros, setParceiros] = useState([])
  const [prestadores, setPrestadores] = useState([])
  const [parceiro, setParceiro] = useState('')
  const [detalhesPedido, setDetalhesPedido] = useState('')
  const [descontoItem, setDescontoItem] = useState([])
  const [dadosEmp, setDadosEmp] = useState([])
  const [isLoading, setLoading] = useState(null)
  const [contas, setConta] = useState([])
  const [contaSelecionada, setContaSelecionada] = useState('')
  const [orderID, setIdpedidoLoja] = useState('')
  const [endEnt, setEndEnt] = useState('')
  const [showAddressModal, setShowAddressModal] = useState(false)
  const [frete, setFrete] = useState(0)
  const [cobraFrete, setCobraFrete] = useState('')
  const calcRef = useRef()
  const [totalCompra, setTotalCompra] = useState(0)
  const [diasParcelas, setDiasParcelas] = useState('')
  const [resultado, setResultado] = useState([])
  const [loadingTela, setLoadingTela] = useState(null)
  const [nfePedido, setNfepedido] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [showModalEst, setShowModalEst] = useState(false)
  const [idNFe, setIdNfe] = useState('')
  const [produtosEstoque, setProdutosEstoque] = useState([])
  const [quantidadesSelecionadas, setQuantidadesSelecionadas] = useState([])
  const [lancContas, setLanContas] = useState('')
  const [statusPedido, setStatus] = useState('')
  const [tipoVenda, setTipoVenda] = useState('')
  const [comissao, setComissao] = useState('')
  const [shipId, setShipID] = useState('')
  const [trackData, setTrackData] = useState([])
  const [acrescimos, setAcrescimos] = useState('')
  const [modalOpen, setModalOpen] = useState(false)
  const [valorDevolvido, setValorDevolvido] = useState('')
  const [itemSelecionado, setItemSelecionado] = useState(null)
  const [inputValue, setInputValue] = useState('')
  const [porc_rt, setPorcRt] = useState('')
  const [porcPrestador, setPorcPrestador] = useState('')
  const [isEditMode, setIsEditMode] = useState({})
  const [reloadData, setReloadData] = useState(false) // Estado para forçar a atualização
  const [isExportOrderLoading, setIsExportOrderLoading] = useState(false)
  const [isModalAttachmentsOpen, setIsModalAttachmentsOpen] = useState(false)
  const [dadosCaixa, setDadosCaixa] = useState(null)
  const [loadingCaixa, setLoadingCaixa] = useState(false)

  const { id_pedido } = useParams()
  const { conta, print } = useParams()
  const navigate = useNavigate()
  const [isLoadingB, setIsLoading] = useState({}) // Estado para controlar o carregamento
  const [showWarningModal, setShowWarningModal] = useState(false)
  const [selectedParcela, setSelectedParcela] = useState(null) // Armazena a parcela selecionada
  const [selectedIndex, setSelectedIndex] = useState(null) // Armazena o índice da parcela
  const [loading, setLoadingEx] = useState(false) // Estado para controle de carregamento

  const [formasPagamento, setFormasPagamento] = useState([])
  const [id_pagamento, setIdPagamento] = useState('')

  const [tipoDuplicatas, setTipoDuplicatas] = useState('dias')
  const [quantidadeParcelas, setQuantidadeParcelas] = useState('')
  const [diaDoMes, setDiaDoMes] = useState('')
  const [mensagem, setMensagem] = useState('') // Estado para armazenar a mensagem
  const [skus, setSkus] = useState([]) // Estado para armazenar SKUs
  const [block, setBlock] = useState(false)
  const [isOrderFileLoading, setIsOrderFileLoading] = useState(false)
  const [isLoadingDeleteAttachment, setIsLoadingDeleteAttachment] = useState({})
  const [isLoadingDeleteAllAttachments, setIsLoadingDeleteAllAttachments] =
    useState(false)

  const [isModalOpen, setIsModalOpen] = useState(false) // Estado para controlar o modal
  const [formaPagamento, setFormaPagamento] = useState('') // Estado para a forma de pagamento
  const [troco, setTroco] = useState(0) // Estado para o troco
  const [valorTotal, setValorTotal] = useState(vl_total) // Simulação do valor total a ser pago
  const [valorRecebido, setValorRecebido] = useState(0) // Estado para o valor recebido
  const [pagamentos, setPagamentos] = useState([])
  const [saldoPendente, setSaldoPendente] = useState(0)
  const [caixasAbertos, setCaixasAbertos] = useState([])
  const [idCaixaSelecionado, setIdCaixaSelecionado] = useState('')
  const [fromDate, setFromDate] = useState(new Date())
  const [recalculateParcels, setRecalculateParcels] = useState(false)
  const [complemento, setComplemento] = useState('')
  const [isProcessing, setIsProcessing] = useState(false)
  const [isLoadingCep, setIsLoadingCep] = useState(false)
  const [showPDFModal, setShowPDFModal] = useState(false)
  const [showImportModal, setShowImportModal] = useState(false)
  const [orcamentoIdInput, setOrcamentoIdInput] = useState('')
  const [importandoOrcamento, setImportandoOrcamento] = useState(false)
  const [isAttachmentsLoading, setIsAttachmentsLoading] = useState(false)
  const [isFinalizandoPagamento, setIsFinalizandoPagamento] = useState(false)

  const consultarCaixa = async () => {
    try {
      setLoadingCaixa(true)
      const response = await apinode.get(
        `/pedido/conferecaixa/${id_pedido}/${localStorage.idconta}`
      )
      const dados = response.data
      setDadosCaixa(dados)
      setSaldoPendente(dados.saldo_restante)
    } catch (error) {
      // Se não tem registros ainda, saldo = total - abatimento
      const saldoInicial = parseFloat(vl_total) - parseFloat(valorDevolvido || 0)
      setSaldoPendente(parseFloat(saldoInicial.toFixed(2)))
      setDadosCaixa(null)
    } finally {
      setLoadingCaixa(false)
    }
  }

  // Substitua a função importBudgetData existente por esta versão corrigida:
  // Substitua a função importBudgetData existente por esta versão corrigida:

  const importBudgetData = async (budgetData) => {
    try {
      console.log('Importando dados do orçamento:', budgetData)

      // Verificar se budgetData é um array (lista de itens) ou um objeto com propriedade itens
      let itensParaImportar = []

      if (Array.isArray(budgetData)) {
        // Se budgetData é um array, usar diretamente
        itensParaImportar = budgetData
      } else if (budgetData.itens && Array.isArray(budgetData.itens)) {
        // Se budgetData tem propriedade itens
        itensParaImportar = budgetData.itens
      } else {
        toast.warning('Formato de dados do orçamento não reconhecido.')
        return
      }

      // Importar produtos/itens
      if (itensParaImportar.length > 0) {
        const produtosImportados = itensParaImportar.map((item) => ({
          id: item.ID || uuidv4(), // Usar ID do item ou gerar novo
          codigo: item.CODIGO || '999999', // SKU do produto
          descricao: item.DESCRICAO || 'Produto importado',
          quantidade:
            parseFloat(item.QUANTIDADE) ||
            parseFloat(item.QUANTIDADE_NOVA) ||
            1,
          quantidade_nova:
            parseFloat(item.QUANTIDADE_NOVA) ||
            parseFloat(item.QUANTIDADE) ||
            1,
          valorunitario: parseFloat(item.VALORUNITARIO) || 0,
          valor_total_item:
            parseFloat(item.VALOR_TOTAL_ITEM) ||
            parseFloat(item.VALOR_NOVO) ||
            parseFloat(item.QUANTIDADE) * parseFloat(item.VALORUNITARIO),
          desconto:
            parseFloat(item.DESCONTO) || parseFloat(item.VLR_DESCONTO) || 0,
          obs: item.OBS || 'Importado do orçamento',
          skuExistente: true, // Assumir que existe por padrão
          new: true, // Marcar como novo para o sistema
          grupo_item: item.GRUPO_ITEM || null, // Grupo/ambiente
          preco_custo: parseFloat(item.PRECO_CUSTO) || 0,
          total_custo: parseFloat(item.TOTAL_CUSTO) || 0,
          image: item.IMAGE || null,
          origem: 'ORCAMENTO',
          // Campos adicionais do seu sistema
          gtin: item.GTIN || null,
          localizacao: item.LOCALIZACAO || null,
          seq_item: item.SEQ_ITEM || null,
        }))

        // Perguntar ao usuário como deseja proceder
        const opcao = await Swal.fire({
          title: 'Importar Produtos',
          text: 'Como deseja proceder com os produtos do orçamento?',
          icon: 'question',
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: 'Substituir todos os produtos',
          denyButtonText: 'Adicionar aos existentes',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#d33',
          denyButtonColor: '#3085d6',
        })

        if (opcao.isConfirmed) {
          // Substituir todos os produtos
          setProdutos(produtosImportados)
          toast.success(
            `${produtosImportados.length} produtos importados! Produtos anteriores foram substituídos.`,
          )
        } else if (opcao.isDenied) {
          // Adicionar aos produtos existentes
          setProdutos((prevProdutos) => [
            ...prevProdutos,
            ...produtosImportados,
          ])
          toast.success(
            `${produtosImportados.length} produtos adicionados aos existentes!`,
          )
        } else {
          // Cancelou a importação
          return
        }

        // Forçar recalcular totais após a importação
        setTimeout(() => {
          CalculaTotal()
        }, 100)
      } else {
        toast.warning('Nenhum produto encontrado no orçamento.')
      }

      // Importar outras informações do orçamento se disponíveis
      if (budgetData.observacoes && budgetData.observacoes.trim()) {
        const importarObs = await Swal.fire({
          title: 'Importar Observações?',
          text: `Deseja importar as observações do orçamento?\n\n"${budgetData.observacoes}"`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim, importar',
          cancelButtonText: 'Não',
        })

        if (importarObs.isConfirmed) {
          setDetalhesPedido((prevObs) => {
            const novaObs = prevObs
              ? `${prevObs}\n\n--- Importado do Orçamento ---\n${budgetData.observacoes}`
              : budgetData.observacoes
            return novaObs
          })
        }
      }

      // Importar dados do cliente se disponível e não há cliente selecionado
      if (budgetData.cliente && budgetData.cliente.nome && !nomeCliente) {
        const importarCliente = await Swal.fire({
          title: 'Importar Cliente?',
          text: `Deseja importar os dados do cliente "${budgetData.cliente.nome}"?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim, importar',
          cancelButtonText: 'Não',
        })

        if (importarCliente.isConfirmed) {
          setNomeCliente(budgetData.cliente.nome)
          if (budgetData.cliente.id) {
            setIdCliente(budgetData.cliente.id)
          }
          if (budgetData.cliente.cpf) {
            setCpf(budgetData.cliente.cpf)
          }
        }
      }

      // Importar desconto se houver
      if (budgetData.desconto && parseFloat(budgetData.desconto) > 0) {
        const importarDesconto = await Swal.fire({
          title: 'Importar Desconto?',
          text: `Deseja aplicar o desconto de R$ ${parseFloat(budgetData.desconto).toFixed(2)}?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sim, aplicar',
          cancelButtonText: 'Não',
        })

        if (importarDesconto.isConfirmed) {
          setDesconto(parseFloat(budgetData.desconto))
          // Aplicar o desconto total
          setTimeout(() => {
            handleDescontoTotal(budgetData.desconto)
          }, 200)
        }
      }
    } catch (error) {
      console.error('Erro ao processar dados do orçamento:', error)
      toast.error('Erro ao processar os dados importados do orçamento.')
      throw error
    }
  }

  // Também adicione esta função melhorada para lidar com erros da API:
  // Versão para debugging - adicione este console.log temporariamente
  const handleImportFromModalAPI = async () => {
    if (!orcamentoIdInput.trim()) {
      toast.warning('Digite o ID do orçamento!')
      return
    }

    setImportandoOrcamento(true)

    try {
      // Chamada para a API usando axios
      const response = await apinode.get(
        `/api/orcamentos/${localStorage.idconta}/${orcamentoIdInput.trim()}`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          timeout: 30000, // 30 segundos de timeout
        },
      )

      const budgetData = response.data

      // DEBUG: Log completo da resposta
      console.log('Resposta completa da API:', response)
      console.log('Dados do orçamento:', budgetData)
      console.log('Tipo dos dados:', typeof budgetData)
      console.log('É array?', Array.isArray(budgetData))

      // Validar se os dados retornados são válidos
      if (!budgetData) {
        throw new Error('Nenhum dado retornado pela API')
      }

      // Fechar modal primeiro
      setShowImportModal(false)
      setOrcamentoIdInput('')

      // Determinar quantos itens foram encontrados
      let quantidadeItens = 0
      if (Array.isArray(budgetData)) {
        quantidadeItens = budgetData.length
      } else if (budgetData.itens && Array.isArray(budgetData.itens)) {
        quantidadeItens = budgetData.itens.length
      }

      // Mostrar dados encontrados
      if (quantidadeItens > 0) {
        toast.success(
          `Orçamento encontrado! Processando ${quantidadeItens} itens...`,
        )

        // Aguardar um pouco para que o toast seja exibido
        await new Promise((resolve) => setTimeout(resolve, 500))

        // Importar os dados
        await importBudgetData(budgetData)
      } else {
        toast.warning(
          'Orçamento encontrado, mas não possui itens para importar.',
        )
      }
    } catch (error) {
      console.error('Erro completo:', error)
      console.error('Resposta de erro:', error.response)

      let errorMessage = 'Erro de conexão com o servidor.'

      if (error.response) {
        switch (error.response.status) {
          case 404:
            errorMessage = 'Orçamento não encontrado! Verifique o ID informado.'
            break
          case 401:
            errorMessage = 'Não autorizado. Faça login novamente.'
            break
          case 403:
            errorMessage =
              'Acesso negado. Você não tem permissão para acessar este orçamento.'
            break
          case 500:
            errorMessage =
              'Erro interno do servidor. Tente novamente mais tarde.'
            break
          default:
            errorMessage = `Erro na API: ${error.response.status} - ${error.response.data?.message || 'Erro desconhecido'}`
        }
      } else if (error.code === 'ECONNABORTED') {
        errorMessage = 'Timeout: A requisição demorou muito para responder.'
      } else if (error.message) {
        errorMessage = error.message
      }

      // Mostrar erro específico
      Swal.fire({
        icon: 'error',
        title: 'Erro ao Importar Orçamento',
        text: errorMessage,
        confirmButtonText: 'OK',
      })
    } finally {
      setImportandoOrcamento(false)
    }
  }

  const handleProductsFromPDF = (extractedProducts) => {
    try {
      // Verifica se há produtos válidos
      if (!extractedProducts || extractedProducts.length === 0) {
        toast.warning('Nenhum produto válido para importar')
        return
      }

      // Processa cada produto extraído
      const processedProducts = extractedProducts.map((product) => ({
        id: product.id || uuidv4(),
        codigo: product.codigo || '999999',
        descricao: product.descricao || 'Produto importado',
        quantidade: product.quantidade || 1,
        quantidade_nova: product.quantidade || 1,
        valorunitario: product.valorunitario || 0,
        valor_total_item:
          (product.quantidade || 1) * (product.valorunitario || 0),
        desconto: product.desconto || 0,
        obs: product.obs || 'Importado do PDF',
        skuExistente: product.skuExistente !== false, // Default true se não especificado
        new: true,
        grupo_item: product.grupo_item || 'IMPORTADO',
        preco_custo: 0,
        total_custo: 0,
        image: null,
        origem: product.origem || 'PDF',
      }))

      // Adiciona os produtos à lista existente
      setProdutos((prevProdutos) => [...prevProdutos, ...processedProducts])

      // Força recalcular totais
      setTimeout(() => {
        CalculaTotal()
      }, 100)

      toast.success(
        `${processedProducts.length} produtos importados do PDF com sucesso!`,
      )
    } catch (error) {
      console.error('Erro ao processar produtos do PDF:', error)
      toast.error('Erro ao processar produtos do PDF')
    }
  }

  function scrollToBottom() {
    const height = document.documentElement.scrollHeight

    window.scroll({
      top: height,
      behavior: 'smooth',
    })
  }

  function scrollToTop() {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    })
  }

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(
      produtos.map((produto) => ({
        Sku: produto.codigo,
        Produto: produto.descricao,
        Quantidade: produto.quantidade,
        'Valor Unit.': produto.valorunitario,
        Desconto: produto.desconto,
        'Valor Total': produto.valor_total_item,
        Observação: produto.obs,
      })),
    )

    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Produtos')

    XLSX.writeFile(wb, `ziphub_${produtos[0].id_pedido}.xlsx`)
  }

  const handleModalClose = () => setIsModalOpen(false) // Fecha o modal
  const handleModalShow = () => setIsModalOpen(true) // Abre o modal

  useCommand(AdicionarProduto, ['ctrl', 'a'])

  useEffect(() => {
    if (isModalOpen) {
      apinode
        .get(`pedido/listacaixaaberto/${localStorage.idconta}`)
        .then((response) => {
          setCaixasAbertos(response.data)
        })
        .catch((error) => {
          console.error('Erro ao carregar a lista de caixas abertos:', error)
        })
    }
  }, [isModalOpen])

  const [attachments, setAttachments] = useState([])
  const [novosArquivosPedido, setNovosArquivosPedido] = useState([])

  const [isModalFileOpen, setIsModalFileOpen] = useState(false)

  const { pathname } = useLocation()

  async function handleExportOrderToBHDatabase(orderId) {
    try {
      if (resultado.length === 0) {
        toast.warning('Preencha as modalidades de pagamento')
        return
      }

      setIsExportOrderLoading(true)

      await PedidosService.exportOrderToBelaHomeDatabase(orderId)

      toast.success('Pedido exportado com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao exportar o pedido!')
    } finally {
      setIsExportOrderLoading(false)
    }
  }

  async function handleSaveOrderFile() {
    try {
      setIsOrderFileLoading(true)

      const attachments = novosArquivosPedido.map((arquivo) => ({
        ...arquivo,
        pedido: id_pedido,
      }))

      await OrderFileService.create(attachments)

      await buscapedido(id_pedido)

      toast.success('Arquivos salvos com sucesso!')
      setIsModalFileOpen(false)
      setIsModalAttachmentsOpen(true)
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível adicionar o arquivo no pedido!',
      )
    } finally {
      setIsOrderFileLoading(false)
    }
  }

  function handleSelectFiles(e) {
    const fileInput = document.querySelector('input.fileInput')

    const files = e.target.files

    for (const file of files) {
      if (file.type !== 'application/pdf') {
        fileInput.value = ''

        return toast.error('Apenas arquivos PDF são permitidos!')
      }
    }

    for (const file of files) {
      setNovosArquivosPedido((prevState) => [
        ...prevState,
        {
          id: v4(),
          file,
          descricao: '',
        },
      ])
    }
  }

  // Função para tratar a entrada do valor recebido
  const handleValorRecebidoChange = (e) => {
    let input = e.target.value

    // Substitui vírgula por ponto para suportar entrada decimal com vírgula
    input = input.replace(',', '.')

    // Regex para permitir apenas números e ponto decimal
    if (/^\d*\.?\d*$/.test(input)) {
      setValorRecebido(input)
    }
  }

  const handleAdicionarPagamento = () => {
    // Converte o valor recebido, permitindo vírgula como separador decimal
    const valor = parseFloat(valorRecebido.replace(',', '.'))

    // Verifica se o valor inserido é válido
    if (isNaN(valor) || valor <= 0) {
      alert('Valor inválido! Insira um valor válido.')
      return
    }

    // Calcula o saldo atualizado (após o pagamento)
    const saldoAtualizado = Math.max(
      parseFloat((saldoPendente - valor).toFixed(2)),
      0,
    ) // Arredondando para 2 casas decimais e evitando valor negativo

    // Calcula o troco se o valor pago for maior que o saldo pendente
    let trocoCalculado = 0
    if (valor > saldoPendente) {
      trocoCalculado = parseFloat((valor - saldoPendente).toFixed(2)) // Arredondar para 2 casas decimais
    }

    // Cria o novo pagamento
    const novoPagamento = { forma: formaPagamento, valor }

    // Atualiza os pagamentos
    setPagamentos([...pagamentos, novoPagamento])

    // Atualiza o saldo pendente
    setSaldoPendente(saldoAtualizado)

    // Atualiza o troco (arredondado)
    setTroco(trocoCalculado)

    // Limpa os campos de entrada
    setValorRecebido('')
    setFormaPagamento('')

    // Log para debugar
    console.log(`Saldo Atualizado: ${saldoAtualizado}`)
    console.log(`Troco Calculado: ${trocoCalculado}`)
  }

  const AddPgto = () => {
    // Aqui você pode adicionar a lógica para totalizar, calcular o troco e lançar no caixa
    console.log(`Forma de Pagamento: ${formaPagamento}, Troco: ${troco}`)

    // Lançar no caixa (simulação)
    Subtotais('Resumo') // Função que totaliza e fecha o pedido

    handleModalClose() // Fecha o modal após a operação
  }

  const handleGerarBoleto = async (codigoParcela, index) => {
    // Exibir o modal grande para confirmação
    setSelectedParcela(codigoParcela)

    setSelectedIndex(index)
    setShowWarningModal(true)
  }

  useEffect(() => {
    if (id_pedido) {
      validarMLB(id_pedido)
    }
  }, [id_pedido]) // Dependência: executa quando id_pedido muda

  function pressF2() {
    setEstaBuscando((prevState) => !prevState)
  }

  useCommand(pressF2, ['F2'])

  function handleChangeDataVencimento(value, index) {
    setResultado((prevState) =>
      prevState.with(index, { ...prevState[index], datavencimento: value }),
    )
  }

  const handleProceedWithBoleto = async () => {
    setShowWarningModal(false) // Fechar o modal

    setIsLoading((prevState) => ({ ...prevState, [selectedIndex]: true }))

    try {
      const body = {
        idDuplicata: selectedParcela, // Usar a parcela armazenada
        cod_pessoa: id_cliente,
      }

      const response = await apinode.post(
        `/sicredi/gerar_bol_sicredi/${localStorage.idconta}`,
        body,
      )

      console.log('Boleto gerado com sucesso:', response.data)
      toast.success('Boleto gerado com sucesso!', response.data.message)
      buscapedido(id_pedido)
    } catch (error) {
      console.error('Erro ao gerar o boleto:', error.response.data.error)
      toast.error(error.response.data.error)
    } finally {
      setIsLoading((prevState) => ({ ...prevState, [selectedIndex]: false }))
    }
  }

  async function handleDeleteFile(id, index) {
    try {
      setIsLoadingDeleteAttachment((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      await OrderFileService.delete(id)

      buscapedido(id_pedido)
      loadAttachments()

      toast.success('Arquivo deletado com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível deletar o arquivo!')
    } finally {
      setIsLoadingDeleteAttachment((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  async function loadAttachments() {
    try {
      setIsAttachmentsLoading(true)

      const data = await OrderFileService.getAll(id_pedido)

      setAttachments(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar os arquivos')
    } finally {
      setIsAttachmentsLoading(false)
    }
  }

  function gerarParcelas() {
    if (id_pagamento === '') {
      return toast.warn(
        'Selecione uma forma de pagamento para gerar as parcelas!',
      )
    }

    const dataPedido = new Date(fromDate)

    const valorPedido = vl_total - valorDevolvido

    const valorParcela = valorPedido / quantidadeParcelas

    setResultado([])

    for (let dia = 1; dia <= Number(quantidadeParcelas); dia++) {
      let proximaData = null

      if (Number(diaDoMes) > getDate(dataPedido)) {
        proximaData = addMonths(dataPedido, dia - 1)
      } else {
        proximaData = addMonths(dataPedido, dia)
      }

      proximaData = setDate(proximaData, Number(diaDoMes))

      setResultado((prevState) => [
        ...prevState,
        {
          datavencimento: format(proximaData, 'yyyy-MM-dd'),
          numero: dia,
          obs: '',
          valor: valorParcela,
        },
      ])
    }
  }

  /*   const handleProceedWithBoleto = async (codigoParcela, index) => {
    setShowWarningModal(false); // Fechar o modal

    setIsLoading((prevState) => ({
      ...prevState,
      [index]: true,
    }));

    try {
      const body = {
        idDuplicata: codigoParcela,
        cod_pessoa: id_cliente,
      };

      const response = await apinode.post(
        `/sicredi/gerar_bol_sicredi/${localStorage.idconta}`,
        body
      );

      console.log("Boleto gerado com sucesso:", response.data);
      toast.success("Boleto gerado com sucesso!", response.data.message);
      buscapedido(id_pedido);
    } catch (error) {
      console.error("Erro ao gerar o boleto:", error);
      toast.error("Erro ao gerar o boleto!", error.message);
    } finally {
      setIsLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }));
    }
  }; */

  const handleImprimirBoleto = async (linhaDigitavel, index) => {
    setIsLoading((prevState) => ({ ...prevState, [index]: true }))

    try {
      // Fazer a requisição GET para obter o PDF
      const response = await apinode.get(
        `/sicredi/imprimir_bol_sicredi/${localStorage.idconta}`,
        {
          params: {
            linhaDigitavel: linhaDigitavel, // Certifique-se de que 'linhaDigitavel' é definido no contexto
            idcliente: id_cliente, // Passa o id_cliente como query string
          },
          responseType: 'blob', // Configura a resposta para ser um blob (binário)
        },
      )

      // Criar uma URL para o blob recebido
      const file = new Blob([response.data], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file)

      // Abrir o PDF em uma nova aba
      window.open(fileURL, '_blank')

      console.log('Boleto gerado com sucesso:', response.data)
      toast.success('Boleto gerado com sucesso!')
    } catch (error) {
      console.error('Erro ao gerar o boleto:', error)
      toast.error('Erro ao gerar o boleto:', error.message)
    } finally {
      setIsLoading((prevState) => ({ ...prevState, [index]: false }))
    }
  }

  const handleEnviarBoleto = async (linhaDigitavel, index) => {
    setIsLoading((prevState) => ({ ...prevState, [index]: true }))

    try {
      // Fazer a requisição GET para obter o PDF
      const response = await apinode.get(
        `/sicredi/enviarBoleto/${localStorage.idconta}`,
        {
          params: {
            linhaDigitavel,
            idcliente: id_cliente,
            empresa: localStorage.nomeconta,
          }, // Passa o codigoParcela como query string
          responseType: 'blob', // Configura a resposta para ser um blob (binário)
        },
      )

      /*    // Criar uma URL para o blob recebido
      const file = new Blob([response.data], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file)

      // Abrir o PDF em uma nova aba
      window.open(fileURL, '_blank') */

      console.log('Boleto gerado com sucesso:', response.data)
      toast.success('Boleto gerado com sucesso!')
    } catch (error) {
      console.error('Erro ao gerar o boleto:', error)
      toast.error('Erro ao gerar o boleto:', error.message)
    } finally {
      setIsLoading((prevState) => ({ ...prevState, [index]: false }))
    }
  }

  async function validarMLB(id_pedido) {
    try {
      const response = await apinode.get(
        `/pedido/validamlb/${localStorage.idconta}`,
        { params: { pedido: id_pedido } },
      )

      if (response.data.success) {
        const sellerSKUs = response.data.seller_skus || [] // Garante que seller_skus é um array
        setSkus(sellerSKUs) // Armazena os SKUs no estado

        // Mensagem de sucesso com o ícone
        const mensagemSucesso = `
                Pedido validado com sucesso! MLB: ${response.data.mlb}.
                SKUs: ${sellerSKUs.join(', ')}.
            `
        setMensagem(mensagemSucesso)
      } else {
        console.warn('Erro:', response.data.message)
        // Verifica se a mensagem é sobre o pedido não ser do Mercado Livre
        if (response.data.message === 'Pedido não é do Mercado Livre.') {
          setMensagem('') // Não exibe nada se não for do Mercado Livre
        } else if (
          response.data.message === 'Anúncio não encontrado para este MLB.'
        ) {
          setMensagem(`Anúncio não encontrado para o MLB.
                Por favor, verifique o código e tente novamente.`)
          setBlock(true)
        } else {
          setMensagem(`Erro na validação do pedido. Tente novamente.`)
        }
        setSkus([]) // Limpa SKUs se houver erro
      }
    } catch (error) {
      console.error('Erro na requisição:', error.message)
      setMensagem(`Erro na validação do pedido. Tente novamente.`)
      setSkus([]) // Limpa SKUs em caso de erro
    }
  }

  async function consultarSaldo({ codPessoa }) {
    try {
      const { saldo_atual, pedidos_devolucoes } =
        await PessoasService.getBalanceByCodPessoa({ codPessoa })

      return { saldo_atual, pedidos_devolucoes }
    } catch (err) { }
  }

  function handleImg(value, index) {
    setProdutos((prevProdutos) => {
      const newProdutos = [...prevProdutos]
      newProdutos[index].image = value
      return newProdutos
    })
  }

  function handleComissaoProduto(value, index) {
    setProdutos((prevProdutos) => {
      const newProdutos = [...prevProdutos]
      newProdutos[index].comissao_sobre_produto = value
      return newProdutos
    })
  }

  const handleEstruturar = async (order) => {
    try {
      const response = await apinode.get(
        `/pedido/restruturar/${localStorage.idconta}`,
        { params: { pedido: order } },
      )

      if (response.status === 200) {
        console.log('Solicitado com sucesso!')
        toast.success(response.data.message)
        // Recarregar a página após o sucesso
        //setPedido('')
      } else {
        console.error('Erro ao estruturar. Resposta:', response.data.error)
        toast.error(
          'Erro ao solicitar estrutura ao backend. Resposta:',
          response.data.error,
        )
        //setPedido('')
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        console.log('pedido com conferencia')
        toast.error(
          'Pedido com itens conferidos. Por favor, faça realize estorno',
        )
      } else {
        console.error('Erro ao buscar contas:', error)
        toast.error('Erro ao solicitar estrutura. Resposta:', error)
      }
      // setPedido('')
    }
  }

  const handleChange = (event) => {
    // Atualiza o estado com o novo valor
    setAcrescimos(event.target.value)
  }

  const handleInserir = () => {
    if (itemSelecionado !== null && inputValue.trim() !== '') {
      const novosProdutos = [...produtos]
      novosProdutos[itemSelecionado] = {
        ...novosProdutos[itemSelecionado],
        grupo_item: inputValue?.toUpperCase(),
      }

      // Agrupa os produtos pelo campo grupo_item
      const produtosAgrupados = novosProdutos.reduce((acc, produto) => {
        const grupo = produto.grupo_item
        if (!acc[grupo]) {
          acc[grupo] = []
        }
        acc[grupo].push(produto)
        return acc
      }, {})

      // Converte o objeto agrupado de volta para um array
      const produtosAgrupadosArray = Object.values(produtosAgrupados).flat()

      // Atualiza o estado de produtos com o array agrupado
      setProdutos(produtosAgrupadosArray)

      setItemSelecionado(null) // Fecha o modal após a inserção
      setInputValue('') // Limpa o valor do input
    }
  }

  const handleInputChange = (e) => {
    setInputValue(e.target.value)
    if (itemSelecionado !== null) {
      const novosProdutos = [...produtos]
      novosProdutos[itemSelecionado] = {
        ...novosProdutos[itemSelecionado],
        grupo_item: e.target.value.trim()
          ? e.target.value.toUpperCase()
          : e.target.value,
      }
      setProdutos(novosProdutos)
    }
  }

  const handleOpenModalTrack = async () => {
    try {
      const response = await apinode.get(`/kangu/consultar`, {
        params: { conta: localStorage.idconta, rastreio: shipId },
      })

      if (response.status === 200) {
        setTrackData(response.data)
        setModalOpen(true)
      } else {
        console.error(
          'Erro ao solicitar dados ao backend. Resposta:',
          response.data,
        )
        toast.error(
          `Erro ao solicitar dados ao backend. Resposta: ${response.data}`,
        )
        setModalOpen(true)
      }
    } catch (error) {
      console.error('Erro ao buscar contas:', error)
      toast.error(`Erro ao solicitar estorno. Resposta: ${retorno}`)
      setModalOpen(true)
      // setPedido('');
    }
  }

  const handleCloseModalTrack = () => {
    setModalOpen(false)
  }

  const handleEstorno = async (order) => {
    let retorno
    if (window.confirm('Tem certeza que deseja estornar este pedido?')) {
      try {
        const response = await apinode.get(
          `/pedido/estornoPedido/${order}/${localStorage.idconta}`,
          { params: { pedido: order } },
        )

        retorno = response.data
        if (response.status === 200) {
          console.log('Estorno realizado')
          toast.success(response.data.message)
          // setPedido('');
        } else {
          console.error(
            'Erro ao solicitar estorno ao backend. Resposta:',
            response.data,
          )
          toast.error(
            `Erro ao solicitar estorno ao backend. Resposta: ${response.data}`,
          )
          //  setPedido('');
        }
      } catch (error) {
        console.error('Erro ao buscar contas:', error)
        toast.error(`Erro ao solicitar estorno. Resposta: ${retorno}`)
        // setPedido('');
      }
    }
  }

  async function handleBaixarEstoque() {
    try {
      setLoading(true)

      if (quantidadesSelecionadas && quantidadesSelecionadas.length > 0) {
        const response = await apinode.put(
          `/pedido/itens/${id_pedido}/${localStorage.idconta}`,
          quantidadesSelecionadas,
        )

        toast.success(response.data.message || 'Estoque baixado com sucesso!')
        await buscapedido(id_pedido)
        handleCloseModalEst()
      } else {
        toast.warning('Nenhum produto para baixar no estoque.')
      }
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível realizar a baixa')
    } finally {
      setLoading(false)
    }
  }

  const handleCusto = async (vlr, index) => {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].preco_custo = vlr || 0
    updatedProdutos[index].total_custo =
      updatedProdutos[index].quantidade_nova * vlr || 0
    setProdutos(updatedProdutos)
  }

  function recalcularParcelas(index) {
    if (recalculateParcels) {
      //? pega parcelas anteriores
      const getParcelasAnteriores = (indexAtual) => {
        return resultado.filter((p, i) => i < indexAtual)
      }

      //? pega parcelas posteriores
      const getParcelasPosteriores = (indexAtual) => {
        return resultado.filter((p, i) => i > indexAtual)
      }

      //? parcela atual
      const parcela = resultado[index]

      const valorTotal = adaptValue(vl_total)
      const valorParcela = adaptValue(parcela?.valor)

      //? valor das parcelas anteriores
      const valorParcelasAnteriores = getParcelasAnteriores(index).reduce(
        (acc, parcela) => {
          const valor = adaptValue(parcela?.valor)

          acc += valor

          return acc
        },
        0,
      )

      //? se soma das parcelas anteriores somadas ao valor da parcela atual for menor igual ao valor do pedido
      if (valorParcelasAnteriores + valorParcela <= valorTotal) {
        const parcelasPosteriores = getParcelasPosteriores(index)

        //? valor restante: valor total - valor das parcelas anteriores + valor da parcela
        const valorRestante =
          valorTotal - (valorParcelasAnteriores + valorParcela)

        //? percorre parcelas posteriores
        for (const parcelaPosterior of parcelasPosteriores) {
          //? index de cada parcela posterior
          const indexParcelaPosterior = resultado.findIndex(
            (p) => p.numero === parcelaPosterior.numero,
          )

          //? atualiza as parcelas de acordo com o index, atualizando o valor restante do valor do pedido dividido pela quantidade de parcelas posteriores
          setResultado((prevState) =>
            prevState.with(indexParcelaPosterior, {
              ...parcelaPosterior,
              valor: valorRestante / parcelasPosteriores.length,
            }),
          )
        }
      } else {
        setResultado((prevState) =>
          prevState.with(index, { ...parcela, valor: '' }),
        )

        return toast.warn(
          'O valor da parcela não pode ser maior que o valor total do pedido!',
        )
      }
    }
  }

  const HandleLanc = async () => {
    if (pathname === '/pedido/editar/novo') {
      return toast.warn('É necessário salvar o pedido primeiro!')
    }

    try {
      // Exibir mensagem de confirmação para o usuário
      const confirmed = window.confirm(
        'Após essa geração, não será permitido gerar mais boletos para esta venda. Deseja continuar?',
      )

      // Se o usuário cancelar, interromper o processo
      if (!confirmed) {
        return toast.info('Geração de boletos cancelada.')
      }

      setLoading(true)

      if (resultado && resultado.length > 0) {
        await SalvarDados()

        const duplicatasFormatted = resultado.map((parcela) => ({
          ...parcela,
          valor: adaptValue(parcela.valor),
          forma_de_pgto: id_pagamento,
        }))

        const response = await apinode.post(
          `/pedido/contasareceber/${id_pedido}/${id_cliente}/${localStorage.idconta}`,
          duplicatasFormatted,
        )

        return toast.success(response.data.message)
      } else {
        return toast.warning('Nenhuma duplicata para lançar!')
      }
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível lançar as contas!')
    } finally {
      setLoading(false)
    }
  }

  const HandleLancContasCaixaQuitado = async (pagamentosRealizados) => {
    if (pathname === '/pedido/editar/novo') return
  
    // Garante que é array
    const pagamentos = Array.isArray(pagamentosRealizados)
      ? pagamentosRealizados
      : pagamentosRealizados?.PAGAMENTOS || []
  
    if (pagamentos.length === 0) return
  
    try {
      // Verifica se já existem parcelas no CR para evitar duplicação
      const resParc = await apinode.get(
        `/pedido/parcelas/${id_pedido}/${localStorage.idconta}`
      )
  
      if (resParc.data && resParc.data.length > 0) {
        console.log('✅ Parcelas já existem no CR, pulando criação de duplicatas')
        return
      }
  
      const duplicatasFormatted = pagamentos.map((p, index) => ({
        numero:         index + 1,
        datavencimento: format(new Date(), 'yyyy-MM-dd'),
        valor:          p.valor,
        obs:            `PDV - ${p.forma}`,
        forma_de_pgto:  id_pagamento || null,
        status_pgto:    'RECEBIDO',
        data_pgto:      format(new Date(), 'yyyy-MM-dd'),
        vlr_recebido:   p.valor,
        linhadigitavel: null,
        nossonumero:    null,
      }))
  
      await apinode.post(
        `/pedido/contasareceber/${id_pedido}/${id_cliente}/${localStorage.idconta}`,
        duplicatasFormatted,
      )
  
      console.log('✅ Duplicatas PDV lançadas como recebidas')
    } catch (err) {
      console.error('Erro ao lançar contas a receber PDV:', err)
    }
  }

  function handleCheckboxChangeEst(produto) {
    setQuantidadesSelecionadas((prevState) => {
      const index = prevState.findIndex((product) => product.sku == produto.sku)

      if (index === -1) {
        return [...prevState, produto]
      } else {
        return prevState.filter((prod) => prod.sku !== produto.sku)
      }
    })
  }

  const HandleEstoque = async () => {
    try {
      setLoading(true)
      const response = await apinode.get(
        `/pedido/itens/${id_pedido}/${localStorage.idconta}`,
      )

      setProdutosEstoque(response.data)
      setShowModalEst(true)
    } catch (error) {
      console.error(error)
      toast.error('Erro ao acessar produtos: ' + error.message)
    } finally {
      setLoading(false)
    }
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }
  const handleCloseModalEst = () => {
    setShowModalEst(false)
  }

  async function HandleCreateNFE() {
    let mensagem = ''

    // await SalvarDados()

    if (nfePedido === 'S') {
      mensagem =
        'Venda já registrada com NFE. Deseja criar uma nova?\n\n' +
        'Ao gerar uma nova NFE para este pedido, você corre o risco de duplicar a documentação fiscal. ' +
        'Isso pode levar a problemas com a Receita Federal e causar confusões para o cliente. ' +
        'Certifique-se de que essa ação é realmente necessSária.\n\n' +
        'Deseja continuar?'
    } else {
      mensagem =
        'Deseja criar NFE para o pedido?\n\n' +
        'Ao gerar uma NFE, certifique-se de que esta ação é necessária para evitar duplicação de documentação fiscal. ' +
        'Prossiga apenas se tiver certeza.\n\n' +
        'Deseja continuar?'
    }

    const confirmacao = window.confirm(mensagem)

    if (!confirmacao) {
      return
    }

    const dados_pedido = {
      valorfrete: frete,
      emp_conta: contaSelecionada,
      codcliente: id_cliente || null,
      datavenda: dt_pedido || moment().format('YYYY-MM-DD'),
      totalpedido: vl_total,
      observacao_interna: `NUMERO DO PEDIDO ${id_pedido}, nickName ${nomeCliente}`,
      natureza: 'S',
      numero_venda: id_pedido,
      valorfrete: frete,
      itens: produtos,
      idnfe: id_nfe,
    }

    try {
      setLoading(true)
      const response = await apinode.post(
        `/pedido/nfe/${id_pedido}/${localStorage.idconta}`,
        dados_pedido,
      )

      const novoPedidoId = response.data.idnfe
      setIdNfe(novoPedidoId)
      toast.success(response.data.message)
      setShowModal(true)
    } catch (err) {
      toast.error('Erro ao criar a NFE: ' + err.response.data.error)
    } finally {
      setLoading(false)
    }
  }

  const calcularParcelas = () => {
    let totalfrete = 0
    let total = vl_total - valorDevolvido

    console.log({ total })

    if (id_pagamento === '') {
      return toast.warn(
        'Selecione uma forma de pagamento para gerar as parcelas!',
      )
    }

    if (isNaN(parseFloat(total))) {
      return toast.warn('O valor total da compra não é válido.')
    }

    // Supondo que 'frete' seja o valor do frete
    if (frete > 0) {
      if (
        confirm(
          `Deseja adicionar o valor do frete (${frete}) ao total da compra?`,
        )
      ) {
        totalfrete = frete
        total = parseFloat(total) + parseFloat(totalfrete)
      } else {
        total = parseFloat(total)
      }
    } else {
      total = parseFloat(total)
    }

    console.log({ total })

    const diasArray = diasParcelas
      .split(',')
      .map((dias) => parseInt(dias.trim()))

    if (diasArray.some(isNaN) || diasArray.some((dias) => dias <= 0)) {
      return toast.warn('A entrada de dias de vencimento não é válida.')
    }

    const dt_pedido_obj = new Date(fromDate)

    if (isNaN(dt_pedido_obj.getTime())) {
      return toast.warn('A data do pedido não é válida.')
    }

    const parcelas = diasArray.map((dias, index) => {
      const datavencimento = new Date(dt_pedido_obj)
      datavencimento.setDate(datavencimento.getDate() + dias)

      const valorParcela = total / diasArray.length

      return {
        numero: index + 1,
        datavencimento: format(datavencimento, 'yyyy-MM-dd'),
        valor: valorParcela.toFixed(2),
        obs: '', // Adicione um campo para a observação
      }
    })

    setResultado(parcelas)
  }

  const handleEditarObservacao = (numeroParcela, novaObservacao) => {
    const novasParcelas = resultado.map((parcela) =>
      parcela.numero === numeroParcela
        ? { ...parcela, obs: novaObservacao }
        : parcela,
    )
    setResultado(novasParcelas)
  }

  const handleEditarValor = (numeroParcela, novoValor) => {
    const novasParcelas = resultado.map((parcela) =>
      parcela.numero === numeroParcela
        ? { ...parcela, valor: novoValor }
        : parcela,
    )

    setResultado(novasParcelas)
  }

  const handleExcluirParcela = (index) => {
    const novasParcelas = resultado.filter((parcela, i) => i !== index)

    setResultado(novasParcelas)

    // Recalcular total da compra
    const novoTotal = novasParcelas.reduce(
      (acumulado, parcela) => acumulado + parseFloat(parcela.valor),
      0,
    )

    setTotalCompra(novoTotal.toFixed(2))
  }

  // Supondo que dt_pedido seja a data no formato 'dd/MM/yyyy'

  const HandleCadastrarCliente = (e) => {
    e.preventDefault()
    apinode
      .post(`pessoa/${localStorage.idconta}`, endereco)
      .then((response) => {
        console.log(response.data)
        toast.success('Cliente cadastrado com sucesso!')
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        toast.error('Erro, ' + error.response.data.message)
        // Handle the error appropriately here
        setLoading(false)
      })
  }

  async function buscaCep() {
    if (!endereco.pes_cep) {
      return
    }

    const cep = endereco.pes_cep.replace(/\D/g, '')

    try {
      setIsLoadingCep(true)

      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)

      setEndereco({
        ...endereco,
        pes_ibge: response.data.ibge,
        pes_bairro: response.data.bairro,
        pes_cidade: response.data.localidade,
        pes_uf: response.data.uf,
        pes_logradouro: response.data.logradouro,
      })
    } catch (err) {
      toast.error('Erro ao buscar CEP')
    } finally {
      setIsLoadingCep(false)
    }
  }

  const handleOpenAddressModal = () => {
    setShowAddressModal(true)
  }
  const handleCloseAddressModal = () => {
    setShowAddressModal(false)
  }
  const [endereco, setEndereco] = useState({
    pes_logradouro: '',
    pes_numero: '',
    pes_cidade: '',
    pes_uf: '',
    pes_cep: '',
    pes_telefone: '',
    pes_celular: '',
    pes_tipo: 'F',
    pes_razao: '',
    pes_cnpj_cpf: '',
    cod_tipo_contribuinte: '99',
    pes_bairro: '',
    pes_ibge: '',
    pes_insc_estadual: '',
    pes_complemento: '',
  })

  const handleNomeChange = (e) => {
    setEndereco({ ...endereco, pes_razao: e.target.value })
  }

  const handleCpfCnpjChange = (e) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, '') // Remove todos os caracteres não numéricos
    setEndereco({ ...endereco, pes_cnpj_cpf: rawValue })
  }

  const handleRuaChange = (e) => {
    setEndereco({ ...endereco, pes_logradouro: e.target.value })
  }

  const handleNumeroChange = (e) => {
    setEndereco({ ...endereco, pes_numero: e.target.value })
  }

  const handleCidadeChange = (e) => {
    setEndereco({ ...endereco, pes_cidade: e.target.value })
  }
  const handleRGIEChange = (e) => {
    setEndereco({ ...endereco, pes_insc_estadual: e.target.value })
  }
  const handleEstadoChange = (e) => {
    setEndereco({ ...endereco, pes_uf: e.target.value })
  }
  const handleBairroChange = (e) => {
    setEndereco({ ...endereco, pes_bairro: e.target.value })
  }
  const handleCepChange = (e) => {
    setEndereco({ ...endereco, pes_cep: e.target.value })
  }

  const handlePesIbge = (e) => {
    setEndereco({ ...endereco, pes_ibge: e.target.value })
  }

  const handleTelefoneChange = (e) => {
    setEndereco({ ...endereco, pes_telefone: e.target.value })
  }

  const handleCelularChange = (e) => {
    setEndereco({ ...endereco, pes_celular: e.target.value })
  }

  const handleTipoCadastroChange = (e) => {
    setEndereco({ ...endereco, pes_tipo: e.target.value || 'F' })
  }

  const handleTipoContribuinte = (e) => {
    setEndereco({ ...endereco, cod_tipo_contribuinte: e.target.value })
  }

  const handleContaChange = (event) => {
    setContaSelecionada(event.target.value)
  }

  const handleTipoVenda = (event) => {
    setTipoVenda(event.target.value)
  }

  const fetchAccounts = async () => {
    try {
      const response = await apinode.get(
        `/pedido/contas/${localStorage.idconta}`,
      )

      setConta(response.data)
    } catch (error) {
      console.error('Erro ao buscar contas:', error)
    }
  }

  const clientes = [
    {
      nome: 'João',
      idade: 30,
      email: 'joao@example.com',
      telefone: '(00) 1234-5678',
    },
    {
      nome: 'Maria',
      idade: 25,
      email: 'maria@example.com',
      telefone: '(00) 9876-5432',
    },
    {
      nome: 'Pedro',
      idade: 40,
      email: 'pedro@example.com',
      telefone: '(00) 5555-8888',
    },
  ]

  async function ImpPdf(tipo) {
    try {
      // const response = await apinode.get(`/pedido/signature/${id_pedido}`)

      const formaPagamento = formasPagamento?.find(
        (fp) => fp.cod_forma_pagamento === id_pagamento,
      )?.fpg_descricao

      // const orderedItems = produtos.sort((a, b) => {
      //   const ruaA = String(a.rua).toLowerCase()
      //   const ruaB = String(b.rua).toLowerCase()

      //   const predioA = String(a.predio).toLowerCase()
      //   const predioB = String(b.predio).toLowerCase()

      //   const nivelA = String(a.nivel).toLowerCase()
      //   const nivelB = String(b.nivel).toLowerCase()

      //   const aptoA = String(a.apto).toLowerCase()
      //   const aptoB = String(b.apto).toLowerCase()

      //   if (ruaA !== ruaB) return ruaA > ruaB ? 1 : -1
      //   if (predioA !== predioB) return predioA > predioB ? 1 : -1
      //   if (nivelA !== nivelB) return nivelA > nivelB ? 1 : -1
      //   if (aptoA !== aptoB) return aptoA > aptoB ? 1 : -1

      //   return 0
      // })

      const resultadoFormatted = resultado.map((result) => ({
        ...result,
        datavencimento: formatDateUtils(parseISO(result.datavencimento)),
      }))

      const dados_pedido = {
        valor_frete: frete,
        // assinatura: response.data.image,
        cobra_frete: cobraFrete,
        EnderecoEnt: endEnt,
        numeroorc: id_pedido,
        orderid: orderID,
        cliente: nomeCliente,
        id_cliente: id_cliente || null,
        formaPagamento,
        cod_vendedor: vendedor || null,
        data: dt_pedido || moment().format('YYYY-MM-DD'),
        valor: vl_total,
        desconto: descontoItem || null,
        desconto_din: desconto || 0,
        id_parceiro: indicacaoVenda || null,
        cpf: cpf,
        cod_vendedor: vendedor || null,
        detalhes_pedido: detalhesPedido || 'Não informado',
        itens: produtos,
        empresa: dadosEmp,
        dadosDoCliente: endereco,
        tipo_pedido: tipoVenda,
        idnfe: id_nfe,
        duplicatas: resultadoFormatted,
        valorDevolvido: valorDevolvido,
      }

      localStorage.usa_wms === 'S'
        ? clientesPDF(dados_pedido, tipo)
        : reportOrderNoWMS(dados_pedido, tipo)
    } catch (err) {
      sendErrorApiMessage(err, 'Houve um erro ao imprimir o PDF!')
    }
  }

  const reqToken = async (conta) => {
    try {
      const response = await apinode.get('/emp', {
        params: { token: localStorage.idconta },
      })

      if (response.status === 200) {
        const token = response.data?.ID_CONTA
        console.log('token: ' + token)

        if (!token) {
          // Sessão expirada ou token não encontrado
          swal(
            'Sessão expirada',
            'Por favor, feche e abra novamente.',
            'warning',
          )
        } else {
          // Atribuição para o state ou local storage (se necessário)
          setDadosEmp([response.data]) // Define o state "dadosEmp" com os dados recebidos
          localStorage.setItem('id_conta', token) // Define o "id_conta" no local storage
        }
      } else {
        console.log('Erro ao requisitar token. Status: ' + response.status)
      }
    } catch (error) {
      console.error('Erro na requisição:', error)
      // Tratamento de erro adicional, se necessário
      // Por exemplo, exibir uma mensagem de erro para o usuário
      // swal('Erro na requisição', 'Ocorreu um erro ao buscar o token.', 'error')
    }
  }

  const handleDescontoTotal = (value) => {
    const descontoTotal = adaptValue(value)

    if (isNaN(descontoTotal) || descontoTotal <= 0) {
      // Se o valor do desconto não é um número válido ou é menor ou igual a zero, não aplicamos desconto
      setDesconto(null) // Resetar o desconto para zero

      setProdutos((prevState) =>
        prevState.map((produto) => ({
          ...produto,
          desconto: 0, // Define o desconto de cada produto como zero
          valor_total_item: produto?.quantidade * produto.valorunitario, // Atualiza o valor total do item sem desconto
        })),
      )

      return
    }

    // Calcula o valor total da compra
    const vl_total = produtos.reduce(
      (acc, produto) => acc + (produto.valor_total_item || 0),
      0,
    )

    // Calcula a proporção de desconto que cada item deve receber
    const proporcaoDesconto = descontoTotal / vl_total

    const updatedProdutos = produtos.map((produto) => {
      const quantidade = produto?.quantidade
      const valorUnitario = produto.valorunitario

      if (!isNaN(quantidade) && !isNaN(valorUnitario)) {
        // Calcula o valor total do item com desconto

        const valorTotalItemComDesconto =
          quantidade * valorUnitario -
          proporcaoDesconto * (produto.valor_total_item || 0)

        // Calcula o desconto proporcional para o item atual
        const valorDesconto =
          proporcaoDesconto * (produto.valor_total_item || 0)

        return {
          ...produto,
          desconto: valorDesconto,
          valor_total_item: parseFloat(valorTotalItemComDesconto), // Atualiza o valor total do item com desconto
          valor_novo: quantidade * valorUnitario,
        }
      }

      return produto
    })

    setDesconto(descontoTotal)
    setProdutos(updatedProdutos)
  }

  const handleIdCliente = (id) => {
    setIdCliente(id)
  }

  const handleCpf = (cpf) => {
    setCpf(cpf)
  }

  const handleDescontoChange = (value, index) => {
    const updatedProdutos = [...produtos]
    const produto = updatedProdutos[index]

    console.log({ value })

    const quantidade = adaptValue(produto.quantidade)
    const valorUnitario = adaptValue(produto.valorunitario)
    const desconto = adaptValue(value)

    console.log({ quantidade, valorUnitario, desconto })

    if (!isNaN(quantidade) && !isNaN(valorUnitario) && !isNaN(desconto)) {
      const valorTotalItem = quantidade * valorUnitario - desconto
      produto.valor_total_item = valorTotalItem
      produto.desconto = value
    } else {
      produto.valor_total_item = 0
    }

    setProdutos(updatedProdutos)
  }

  // Função para formatar o número
  const formatarNumero = (numero) => {
    // Usar o toFixed(2) para limitar o número a duas casas decimais
    return numero.toFixed(2).replace('.', ',')
  }

  const parseDecimalValue = (value) => {
    const sanitizedValue = value.replace(',', '.')
    const parsedValue = parseFloat(sanitizedValue)
    return isNaN(parsedValue) ? '' : parsedValue.toFixed(2)
  }

  const alternarModoBusca = () => {
    setEstaBuscando((estadoAnterior) => !estadoAnterior)
  }

  const formatValue = (value) => {
    if (value == null) {
      return '' // Return an empty string or any default value for null or undefined values
    }
    return value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
  }

  const handleNomeCliente = (nome) => {
    setNomeCliente(nome)
    setDadosPedido((prevState) => ({ ...prevState, cliente: nome }))
  }

  const handleObsChange = (value, index) => {
    const updatedProdutos = [...produtos] // Create a copy of the produtos array
    updatedProdutos[index].obs = value // Update the obs value of the corresponding product
    setProdutos(updatedProdutos) // Update the state with the modified array
  }

  function handleProdutoIdChange(id, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].codigo = id
    setProdutos(updatedProdutos)
  }

  function handleProdutoNomeChange(nome, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].descricao = nome
    updatedProdutos[index].quantidade = '1'
    setProdutos(updatedProdutos)
  }

  function handleProdutoNomeChangeInput(nome, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].descricao = nome
    updatedProdutos[index].codigo = '999999'
    setProdutos(updatedProdutos)
  }

  function handleProdutoInternoChange(prodInterno, index) {
    // const updatedProdutos = [...produtos]
    // updatedProdutos[index].id = prodInterno
    // setProdutos(updatedProdutos)
  }

  function AdicionarProduto() {
    const prod = {
      id: uuidv4(),
      codigo: 0,
      descricao: '',
      quantidade_nova: 1,
      valorunitario: 0,
      valor_total_item: 0,
      desconto: 0,
      skuExistente: true,
      new: true,
    }

    setProdutos([...produtos, prod])
  }

  async function ExcluirProduto(produto, index) {
    const confirmar = window.confirm(
      'Você realmente deseja excluir este produto?',
    )

    if (confirmar) {
      if (produto.new) {
        setProdutos((prevState) =>
          prevState.filter((prod) => prod.id !== produto.id),
        )
      } else {
        try {
          setLoadingEx((prevState) => ({ ...prevState, [index]: true }))

          const dadosPedido = {
            id_item: produto.id, // ID do item a ser excluído
            id_user: localStorage.idusuario, // ID do usuário que está fazendo a exclusão
          }

          await apinode.put(
            `pedido/deletar/${id_pedido}/${localStorage.idconta}`,
            { data: dadosPedido },
          )

          const updatedProdutos = produtos.filter(
            (prod) => prod.id !== produto.id,
          )

          setProdutos(updatedProdutos)
          toast.success('Produto excluído com sucesso!')
          buscapedido(id_pedido)
        } catch (err) {
          console.error('Erro ao excluir produto:', err)

          toast.error('Erro ao excluir produto!')
        } finally {
          setLoadingEx((prevState) => ({ ...prevState, [index]: false }))
        }
      }
    } else {
      return
    }
  }

  async function Estornar(sku, id_item, id_pedido) {
    console.log(statusPedido)
    if (statusPedido !== 'Atendido') {
      toast.warning(
        'O pedido não está no status "Atendido". Não é possível estornar.',
      )
      return
    }

    const confirmacao = window.confirm(
      'Tem certeza que deseja estornar este item?',
    )
    if (!confirmacao) {
      console.log('Estorno cancelado pelo usuário.')
      return
    }

    try {
      const response = await apinode.get(
        `/pedido/estorno/${id_item}/${sku}/${id_pedido}/${localStorage.idconta}`,
        {},
      )
      console.log(response.data)
      // Exibir mensagem de sucesso
      toast.success('Estorno realizado com sucesso!')
    } catch (error) {
      console.error('Erro ao estornar:', error)
      // Exibir mensagem de erro
      toast.error('Erro ao estornar o item: ' + error.message)
    }
  }

  async function handleDeleteFiles() {
    const promises = []

    try {
      setIsLoadingDeleteAllAttachments(true)

      for (const attachment of attachments) {
        promises.push(OrderFileService.delete(attachment.id))
      }

      await Promise.all(promises)

      await loadAttachments()

      toast.success('Todos os arquivos foram excluídos com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao excluir os arquivos')
    } finally {
      setIsLoadingDeleteAllAttachments(false)
    }
  }

  const buscapedido = useCallback(async (idpedido, willLoad = true) => {
    try {
      willLoad && setLoadingTela(true)

      const response = await apinode.get(
        `/pedido/pedido-editar/${idpedido}/${localStorage.idconta}`,
      )

      const {
        datadespacho,
        cliente,
        cod_vendedor,
        id_parceiro,
        id_prestador,
        cpf,
        data,
        id_cliente,
        desconto_din,
        detalhes_pedido,
        id_loja,
        idpedidoloja,
        end_ent,
        valor_frete,
        cobra_frete,
        nfe_pedido,
        lanc_contas,
        status,
        tipo_pedido,
        comissao_vendedor,
        ship,
        acrescimos,
        valor_devolvido,
        porc_rt,
        porc_prestador,
        id_pagamento,
      } = response.data.dadospedido

      setIdnfe(response.data.dadospedido.id_nfe)

      const produtosAgrupados = response.data.dadospedido.items.reduce(
        (acc, produto) => {
          const grupo = produto.grupo_item
          if (!acc[grupo]) {
            acc[grupo] = []
          }
          acc[grupo].push(produto)
          return acc
        },
        {},
      )

      // Converte o objeto agrupado de volta para um array
      const produtosAgrupadosArray = Object.values(produtosAgrupados).flat()

      // Atualiza o estado de produtos com o array agrupado
      setProdutos(
        produtosAgrupadosArray.map((produto) => ({ ...produto, new: false })),
      )

      setPrestadorSelecionado(id_prestador)
      setDadosPedido(response.data.dadospedido || {})
      setNomeCliente(cliente || '')
      setVendedor(cod_vendedor || '')
      setIndicacaoVenda(id_parceiro || '')
      setIdCliente(id_cliente || '')
      setCpf(cpf || '')
      setDetalhesPedido(detalhes_pedido || '')
      setDesconto(parseFloat(desconto_din) || '')
      setContaSelecionada(id_loja || '')
      setIdpedidoLoja(idpedidoloja || '')
      setEndEnt(end_ent || '')
      setAcrescimos(acrescimos || '')
      setValorDevolvido(valor_devolvido || '')
      setPorcRt(porc_rt || '')
      setPorcPrestador(porc_prestador || '')
      setIdPagamento(id_pagamento || '')

      const enderecoAtualizado =
        response.data.dadospedido && response.data.dadospedido.dadosCliente[0]

      if (enderecoAtualizado) {
        enderecoAtualizado.pes_complemento =
          response.data.dadospedido.dadosCliente[0].pes_complemento
      }

      // Atualiza o estado com o complemento
      setComplemento(enderecoAtualizado.pes_complemento)

      if (
        enderecoAtualizado?.pes_tipo !== 'F' &&
        enderecoAtualizado?.pes_tipo !== 'J'
      ) {
        enderecoAtualizado.pes_tipo = 'F'
      }

      const duplicatasFormatted = (response?.data?.dadospedido?.duplicatas || []).map(
        (d) => ({
          ...d,
          datavencimento: d.datavencimento
            ? format(parseISO(d.datavencimento), 'yyyy-MM-dd')
            : null,
        }),
      )

      setEndereco(enderecoAtualizado || '')

      const dataFormatada = format(new Date(data), 'yyyy-MM-dd')
      setDtPedido(dataFormatada || '')

      const dataFormatadaEntrega = datadespacho
        ? format(new Date(datadespacho || ''), 'yyyy-MM-dd')
        : null
      setDtEntrega(dataFormatadaEntrega || '')
      setFrete(valor_frete || 0)
      setCobraFrete(cobra_frete || '')
      setResultado(duplicatasFormatted || [])
      setNfepedido(nfe_pedido || '')

      setLanContas(lanc_contas || '')
      setStatus(status || '')
      setTipoVenda(tipo_pedido || '')
      setComissao(comissao_vendedor || '')
      setShipID(ship || '')
    } catch (err) {
      console.error(err)
    } finally {
      willLoad && setLoadingTela(false)
    }
  }, [])

  function formatDate(dateString) {
    if (!dateString) return '' // Handle empty or undefined dateString

    const date = new Date(dateString)

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  }

  function CarregarDadosPedido(id_ped) {
    if (id_ped > 0) {
      //setIdCliente(dadospedido?.id_cliente ?? 0);
      // setNomeCliente(dadospedido?.cliente);
      // setCpf(dadospedido?.cpf)

      const formattedDate = moment(dadospedido?.data).format('YYYY-MM-DD')
      setDtPedido(formattedDate)

      setVendedor(dadospedido?.cod_vendedor)
      setParceiro(dadospedido?.id_parceiro)

      setIdCondPagto(2)
      setDtEntrega('2023-10-30')
      // setObs("Teste");
      // setDesconto(dadospedido?.desconto_din);
      setDetalhesPedido(dadospedido?.detalhes_pedido)
    } else {
      setIdCliente(0)
      setDtPedido(moment().format('YYYY-MM-DD'))
      setIdCondPagto(0)
      setDtEntrega(moment().format('YYYY-MM-DD'))
      setObs('')
      setDesconto(0)
      setVendedor('')
      setIndicacaoVenda('')
      setProdutos([])
    }
  }

  function PesquisarClientes() {
    setListaClientes([])
  }

  function PesquisarProdutos() {
    setListaProdutos([
      { id_item: 1, id_produto: 1, descricao: 'MONITOR DELL' },
      { id_item: 2, id_produto: 2, descricao: 'HD SEAGATE 2TB' },
      { id_item: 3, id_produto: 3, descricao: 'MOUSE LOGITECH' },
    ])
  }

  function PesquisarCondPagtos() {
    setCondPagtos([
      { id_cond_pagto: 1, cond_pagto: '30 Dias' },
      { id_cond_pagto: 2, cond_pagto: '45 Dias' },
    ])
  }

  function handleDescricaoChange(value, index) {
    setProdutos((prevProdutos) => {
      const newProdutos = [...prevProdutos]
      newProdutos[index].descricao = value
      return newProdutos
    })
  }

  const handleBlur = async () => {
    // Lógica para enviar o pedido PUT
    apinode
      .put(`/kangu/${localStorage.idconta}`, {
        rastreio: shipId,
        pedido: id_pedido,
      })
      .then((response) => {
        console.log(response.data)
      })
      .catch((error) => {
        console.error('Erro ao enviar PUT request:', error)
      })
  }

  function recalcularTodosProdutos() {
    const updatedProdutos = produtos.map((produto) => {
      const quantidade = produto.quantidade

      // Recalcula todos os valores baseados na quantidade e outros campos
      return {
        ...produto,
        valor_total_item: quantidade * produto.valorunitario,
        valor_novo: quantidade * produto.valorunitario,
        total_custo: quantidade * produto.preco_custo,
      }
    })

    // Atualiza o estado com o array recalculado
    setProdutos(updatedProdutos)
  }

  function handleQtdChange(qtd, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].quantidade = qtd
    updatedProdutos[index].valor_total_item =
      qtd * updatedProdutos[index].valorunitario
    updatedProdutos[index].valor_novo =
      qtd * updatedProdutos[index].valorunitario
    updatedProdutos[index].total_custo =
      qtd * updatedProdutos[index].preco_custo
    setProdutos(updatedProdutos)
  }

  function handleVlUnitChange(vl, index) {
    const updatedProdutos = [...produtos]
    const produto = updatedProdutos[index]

    produto.valorunitario = vl
    produto.valor_total_item = produto.quantidade * vl
    produto.valor_novo = produto.quantidade * vl

    handleDescontoChange(produto.desconto || 0, index) // Passa o valor do desconto atualizado

    if (
      typeof produto.valor_total_item === 'number' &&
      !isNaN(produto.valor_total_item)
    ) {
      produto.valor_novo = produto.valor_total_item
    } else {
      // Se o valor não for um número válido, trate o erro aqui.
      // Por exemplo, você pode definir como 0 ou exibir uma mensagem de erro.
      produto.valor_novo = produto.valor_total_item
      console.error('Erro: valor_total_item não é um número válido.')
    }

    setProdutos(updatedProdutos)
  }

  function CalculaTotal() {
    let total = 0

    produtos.forEach((prod) => {
      total += prod.valor_total_item
    })

    setVlTotal(total) // Define o valor total sem formatação
    setSaldoPendente(parseFloat(total.toFixed(2))) // Define o saldo pendente como número com duas casas decimais
  }

  async function SalvarDados() {
    if (lancContas === 'S' && localStorage.admin !== 'SIM') {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Pedido já finalizado no financeiro ou você não tem permissão para editar!',
      })
      return
    }

    if (statusPedido === 'Atendido') {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Status do pedido não permite alterações',
      })
      return
    } else if (statusPedido === 'Cancelado') {
      Swal.fire({
        icon: 'info',
        title: 'Pedido Cancelado',
        text: 'O pedido já foi cancelado e não pode ser alterado',
      })
      return
    }

    setIsProcessing(true) // Ativa o loading

    try {
      if (block === true) {
        toast.warning('SKU não encontrado no anúncio.')
      }

      if (!contaSelecionada || contaSelecionada.trim() === 'all') {
        toast.warning('O campo conta é obrigatório.')
        return
      }

      if (!tipoVenda || tipoVenda.trim() === 'all') {
        toast.warning('Selecione o tipo de pedido.')
        document.getElementById('tipovenda').focus()
        return
      }

      if (!nomeCliente) {
        toast.warning('Erro, o campo cliente é obrigatório.')
        return
      }

      const duplicatasFormatted = resultado.map((parcela) => ({
        ...parcela,
        valor: adaptValue(parcela.valor),
      }))

      const produtosFormatted = produtos.map((produto) => {
        const total_comissao =
          adaptValue(produto.valor_total_item) *
          (adaptValue(produto.comissao_sobre_produto) / 100)

        return {
          ...produto,
          porc_comissao: produto.comissao_sobre_produto,
          total_comissao,
        }
      })

      const data = {
        valor_frete: frete,
        id_loja: contaSelecionada,
        cliente: nomeCliente,
        id_cliente: id_cliente || null,
        cod_vendedor: vendedor || null,
        data: dt_pedido || moment().format('YYYY-MM-DD'),
        valor: vl_total,
        desconto: desconto || null,
        desconto_din: desconto || 0,
        id_parceiro: indicacaoVenda || null,
        id_prestador: prestadorSelecionado || null,
        cpf: cpf,
        detalhes_pedido: detalhesPedido || 'Não informado',
        end_ent: endEnt || null,
        itens: produtosFormatted,
        dadosDoCliente: endereco,
        cobra_frete: cobraFrete,
        duplicatas: duplicatasFormatted,
        user: localStorage.idusuario,
        tipo_pedido: tipoVenda || null,
        comissao: comissao || null,
        ship: shipId || null,
        valor_devolvido: valorDevolvido || null,
        porc_rt: Number(porc_rt),
        porc_prestador: Number(porcPrestador),
        id_pagamento,
      }

      if (id_pedido === 'novo') {
        await createOrder(data)
      } else {
        const result = await consultarSaldo({
          codPessoa: id_cliente,
        })

        if (result?.saldo_atual && !valorDevolvido) {
          const {
            isConfirmed,
            value: valueToDiscount,
            isDenied,
          } = await Swal.fire({
            allowEscapeKey: false,
            allowOutsideClick: false,
            title: 'Saldo Disponível!',
            html: `Este cliente possui um saldo de <strong>${formatPrice(
              result?.saldo_atual,
            )}</strong>. Deseja utilizá-lo?`,
            icon: 'info',
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonText: 'Sim',
            denyButtonText: 'Não',
            cancelButtonText: 'Cancelar',
            input: 'text',
            inputLabel: 'Valor a ser abatido',
            inputValidator: (value) => {
              if (adaptValue(value) > adaptValue(result?.saldo_atual))
                return 'Valor maior do que o disponível!'
              if (adaptValue(value) > adaptValue(data.valor))
                return `O limite é de ${formatPrice(adaptValue(data.valor))}`
            },
          })

          if (isConfirmed) {
            let dadosPedido = { ...data }

            if (adaptValue(valueToDiscount) >= adaptValue(data.valor)) {
              dadosPedido = {
                ...dadosPedido,
                valor: 0,
                valor_devolvido: adaptValue(valueToDiscount),
                tipo_pedido: 'TROCA',
              }

              await updateBalance({
                codPessoa: dadosPedido.id_cliente,
                value: valueToDiscount,
                id_pedido,
              })
            } else {
              dadosPedido = {
                ...dadosPedido,
                valor: adaptValue(data.valor) - adaptValue(valueToDiscount),
                valor_devolvido: adaptValue(valueToDiscount),
                tipo_pedido: 'VENDA',
              }

              await updateBalance({
                codPessoa: dadosPedido.id_cliente,
                value: valueToDiscount,
                id_pedido,
              })
            }

            await updateOrder(dadosPedido)
          } else if (isDenied) {
            await updateOrder(data)
          } else {
            return Swal.close()
          }
        } else {
          await updateOrder(data)
        }
      }
    } catch (error) {
      console.error('Erro ao salvar pedido:', error)
      toast.error('Erro ao salvar pedido.')
    } finally {
      setIsProcessing(false) // Desativa o loading ao final do processo
    }
  }

  async function updateBalance({ codPessoa, value, id_pedido }) {
    try {
      await PessoasService.updateBalance({
        codPessoa,
        type: 'saida',
        value,
        id_pedido,
      })
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao atualizar o saldo!')
    }
  }

  async function createOrder(dadosPedido) {
    toast.info('Reservando estoque...')

    toast.info('Parametrizando dados, aguarde...')

    try {
      setLoading(true)

      const response = await apinode.post(
        `/pedido/${localStorage.idconta}`,
        dadosPedido,
      )

      const novoPedidoId = response.data.idpedido

      navigate(`/pedido/editar/${novoPedidoId}`)

      //await handleEstruturar(novoPedidoId)

      toast.success('Pedido criado com sucesso!')

      return novoPedidoId
    } catch (err) {
      console.error(err)
      toast.error('Erro ao criar o pedido: ' + err.message)
    } finally {
      setLoading(false)
    }
  }

  async function updateOrder(dadosPedido) {
    toast.info('Reservando estoque...')
    toast.info('Parametrizando dados...')

    try {
      setLoading(true)
      // Faz o PUT para atualizar o pedido
      await apinode.put(
        `/pedido/${id_pedido}/${localStorage.idconta}`,
        dadosPedido,
      )
      toast.success('Alterações realizadas com sucesso!')

      // await handleEstruturar(id_pedido)

      await buscapedido(id_pedido)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível salvar o pedido')
    } finally {
      setLoading(false)
    }
  }

  const handleCheckboxChange = (event) => {
    // Use event.target.checked to check if the checkbox is checked
    // If checked, set 'S', otherwise set null
    const newValue = event.target.checked ? 'S' : null

    // Set the state using the newValue
    setCobraFrete(newValue)

    console.log('cobrafrete', newValue)
  }

  const handleFinalizarPagamento = async () => {
    if (isFinalizandoPagamento) return // dupla proteção

    const confirmar = window.confirm(
      'Você tem certeza que deseja finalizar o pagamento?'
    )
    if (!confirmar) return

    const executarFinalizacao = async (pagamentosParaLancar) => {
      try {
        setIsFinalizandoPagamento(true) // 🔒 trava

        if (pagamentosParaLancar.length === 0) {
          toast.warn('Não há pagamentos para finalizar.')
          return
        }

        if (!idCaixaSelecionado) {
          toast.warn('Selecione o caixa antes de finalizar.')
          return
        }

        const dadosPagamento = {
          ID_CX: idCaixaSelecionado,
          IDPEDIDO: id_pedido,
          VALORPEDIDO: parseFloat(vl_total) - parseFloat(valorDevolvido || 0),
          PAGAMENTOS: pagamentosParaLancar.map((p) => ({
            FORMA_PGTO: p.forma,
            VLR_RECEBIDO: p.valor,
            TROCO: troco,
          })),
        }

        const response = await apinode.post(
          `/pedido/registro-caixa/${localStorage.idconta}`,
          dadosPagamento,
        )

        if (!response || response.status !== 201) {
          throw new Error(
            `Erro ao enviar pagamentos: ${response?.statusText || 'sem resposta'}`
          )
        }

        await HandleLancContasCaixaQuitado(pagamentosParaLancar)

        toast.success('Pagamentos confirmados e lançados no caixa com sucesso!')
        handleModalClose()
        consultarCaixa()

      } catch (error) {
        toast.error(`Erro ao finalizar os pagamentos: ${error.message}`)
        console.error('Erro ao finalizar os pagamentos:', error)
      } finally {
        setIsFinalizandoPagamento(false) // 🔓 libera sempre
      }
    }

    if (saldoPendente > 0) {
      toast.info(
        ({ closeToast }) => (
          <div>
            <strong>Saldo restante: R$ {saldoPendente.toFixed(2)}</strong>
            <p className="mb-2 mt-1" style={{ fontSize: 13 }}>
              O pedido ainda não está totalmente pago. Deseja lançar como
              <strong> pagamento parcial</strong> e continuar?
            </p>
            <div className="d-flex gap-2">
              <button
                className="btn btn-sm btn-primary"
                onClick={async () => {
                  closeToast()
                  await executarFinalizacao(pagamentos)
                }}
              >
                Sim, lançar parcial
              </button>
              <button className="btn btn-sm btn-secondary" onClick={closeToast}>
                Cancelar
              </button>
            </div>
          </div>
        ),
        { autoClose: false, closeOnClick: false },
      )
      return
    }

    await executarFinalizacao(pagamentos)
  }

  const handleTextoChange = (texto) => {
    setTextoDigitado('texto' + texto)
  }

  useEffect(() => {
    reqToken(localStorage.idconta)
    localStorage.setItem('id_conta', localStorage.idconta)
    PesquisarClientes()
    PesquisarProdutos()
    PesquisarCondPagtos()

    if (id_pedido > 0) {
      buscapedido(id_pedido)
    } else {
      const now = new Date()

      const dataFormatada = now.toISOString().slice(0, 10)

      setDtPedido(dataFormatada)
    }

    if (desconto > 0) {
      handleDescontoTotal()
    }
  }, [buscapedido])

  useEffect(() => {
    const prepararParaImpressao = async () => {
      await CalculaTotal() // Aguarda a conclusão de CalculaTotal()

      if (print === 'print') {
        ImpPdf('Completo')
      }
    }

    prepararParaImpressao() // Chama a função assíncrona
  }, [produtos])

  useEffect(() => {
    ; (async () => {
      try {
        const response = await apinode.get(
          `/vendedores/prestador?conta=${localStorage.idconta}`,
        )

        setPrestadores(response.data)
      } catch (err) {
        sendErrorApiMessage(err, 'Não foi possível buscar os prestadors!')
      }
    })()
  }, [])

  useEffect(() => {
    fetchAccounts()

    // Fazer a requisição para obter os vendedores
    apinode
      .get(`vendedores/vendedor?conta=${localStorage.idconta}`)
      .then((response) => {
        setVendedores(response.data)
      })
      .catch((error) => {
        console.error(error)
      })

    apinode
      .get(`vendedores/parceiros?conta=${localStorage.idconta}`)
      .then((response) => {
        setParceiros(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])

  if (parceiros.length > 0) {
    parceiros.sort((a, b) => {
      const nomeA = a.PES_RAZAO.toLowerCase()
      const nomeB = b.PES_RAZAO.toLowerCase()
      if (nomeA < nomeB) {
        return -1
      }
      if (nomeA > nomeB) {
        return 1
      }
      return 0
    })
  }

  async function getPaymentForms() {
    try {
      const response = await apinode.get(
        `/formas-pagamento/${localStorage.idconta}`,
      )

      setFormasPagamento(response.data)
    } catch (err) {
      sendErrorApiMessage(
        err,
        'Não foi possível buscar as formas de pagamento!',
      )
    }
  }

  useEffect(() => {
    if (reloadData) {
      // Verifica se o id_pedido é maior que 0 antes de chamar a função de busca
      if (id_pedido > 0) {
        buscapedido(id_pedido) // Chama a função para buscar o pedido
      }

      // Após a atualização ou verificação, redefina `reloadData` para false
      setReloadData(false)
    }
  }, [reloadData, id_pedido]) // Adiciona `id_pedido` como dependência

  useEffect(() => {
    getPaymentForms()
  }, [])

  return (
    <>
      <Navbar />

      {/* CSS Personalizado */}
      <style jsx>{`
        .modern-container {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          min-height: 100vh;
          padding: 20px 0;
        }

        .main-card {
          background: white;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          border: none;
          overflow: hidden;
          margin-bottom: 20px;
        }

        .card-header-modern {
          background: linear-gradient(135deg, #4f46e5, #7c3aed);
          color: white;
          padding: 24px;
          border: none;
        }

        .section-divider {
          border-bottom: 2px solid #e2e8f0;
          margin: 30px 0;
          padding-bottom: 15px;
        }

        .form-section {
          background: #f8fafc;
          border-radius: 12px;
          padding: 24px;
          margin-bottom: 20px;
          border: 1px solid #e2e8f0;
        }

        .section-title {
          color: #374151;
          font-weight: 600;
          font-size: 1.2rem;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .form-label-modern {
          color: #6b7280;
          font-weight: 500;
          font-size: 0.875rem;
          margin-bottom: 6px;
          text-transform: uppercase;
          letter-spacing: 0.025em;
        }

        .form-control-modern {
          border: 2px solid #e5e7eb;
          border-radius: 8px;
          padding: 12px;
          transition: all 0.2s ease;
          font-size: 14px;
        }

        .form-control-modern:focus {
          border-color: #4f46e5;
          box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
          outline: none;
        }

        .status-badge {
          padding: 10px 16px;
          border-radius: 50px;
          font-weight: 600;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .status-atendido {
          background: linear-gradient(135deg, #10b981, #059669);
          color: white;
        }

        .status-cancelado {
          background: linear-gradient(135deg, #ef4444, #dc2626);
          color: white;
        }

        .status-aberto {
          background: linear-gradient(135deg, #f59e0b, #d97706);
          color: white;
        }

        .btn-modern {
          border-radius: 8px;
          font-weight: 500;
          padding: 10px 20px;
          border: none;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .btn-primary-modern {
          background: linear-gradient(135deg, #4f46e5, #7c3aed);
          color: white;
        }

        .btn-primary-modern:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(79, 70, 229, 0.3);
        }

        .btn-success-modern {
          background: linear-gradient(135deg, #10b981, #059669);
          color: white;
        }

        .btn-warning-modern {
          background: linear-gradient(135deg, #f59e0b, #d97706);
          color: white;
        }

        .btn-danger-modern {
          background: linear-gradient(135deg, #ef4444, #dc2626);
          color: white;
        }

        .table-modern {
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          border: none;
        }

        .table-modern thead {
          background: linear-gradient(135deg, #f8fafc, #e2e8f0);
        }

        .table-modern th {
          border: none;
          padding: 16px;
          font-weight: 600;
          color: #374151;
          text-transform: uppercase;
          font-size: 0.75rem;
          letter-spacing: 0.05em;
        }

        .table-modern td {
          border: none;
          padding: 16px;
          vertical-align: middle;
          border-bottom: 1px solid #f3f4f6;
        }

        .input-group-modern .form-control {
          border-right: none;
        }

        .input-group-modern .btn {
          border-left: none;
          border-color: #e5e7eb;
        }

        .alert-modern {
          border-radius: 12px;
          border: none;
          padding: 16px 20px;
          margin: 20px 0;
        }

        .modal-modern .modal-content {
          border-radius: 16px;
          border: none;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
        }

        .modal-modern .modal-header {
          background: linear-gradient(135deg, #4f46e5, #7c3aed);
          color: white;
          border: none;
          border-radius: 16px 16px 0 0;
        }

        .floating-total {
          position: sticky;
          bottom: 20px;
          background: white;
          border-radius: 12px;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
          padding: 20px;
          border: 2px solid #4f46e5;
        }

        @media (max-width: 768px) {
          .form-section {
            padding: 16px;
          }

          .main-card {
            border-radius: 8px;
            margin: 10px;
          }
        }
      `}</style>

      {loadingTela ? (
        <div className="modern-container">
          <div className="text-center">
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: '3rem', height: '3rem' }}
            >
              <span className="visually-hidden">Carregando...</span>
            </div>
            <p className="mt-3 text-muted">Carregando dados do pedido...</p>
          </div>
        </div>
      ) : (
        <div className="modern-container">
          <div
            className="container-fluid"
            style={{
              position: 'relative',
            }}
          >
            {/* Alerta MercadoPago */}
            {mensagem && (
              <div className="alert alert-info alert-modern d-flex align-items-center">
                <SiMercadopago
                  size={24}
                  className="me-3"
                />
                <span>{mensagem}</span>
              </div>
            )}

            {/* Card Principal */}
            <div className="main-card">
              {/* Cabeçalho com Status */}
              <div className="card-header-modern">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                  <h1 className="h3 mb-0">
                    {id_pedido > 0
                      ? `Pedido de Venda #${id_pedido}`
                      : 'Novo Pedido'}
                  </h1>

                  <div
                    className={`status-badge ${statusPedido === 'Atendido'
                      ? 'status-atendido'
                      : statusPedido === 'Cancelado'
                        ? 'status-cancelado'
                        : 'status-aberto'
                      }`}
                  >
                    {statusPedido === 'Atendido' && <CheckCircle size={18} />}
                    {statusPedido === 'Cancelado' && <XCircle size={18} />}
                    {statusPedido === 'Em aberto' && <Clock size={18} />}
                    {statusPedido}
                  </div>
                </div>
              </div>

              <div
                className="p-4"
                style={{ position: 'relative' }}
              >
                {/* Seção: Dados do Cliente */}
                <div className="form-section">
                  <h4 className="section-title">
                    <i className="bi bi-person-circle"></i>
                    Dados do Cliente
                  </h4>

                  <div className="row g-3">
                    <div className="col-md-8">
                      <label className="form-label form-label-modern">
                        Cliente
                      </label>
                      <div className="input-group input-group-modern">
                        <AutocompleteClienteNode
                          placeholder="Pesquisar cliente..."
                          onClickNome={handleNomeCliente}
                          onClickId={handleIdCliente}
                          onClickCpf={handleCpf}
                          value={nomeCliente}
                          className="form-control form-control-modern"
                        />
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-modern"
                          onClick={handleOpenAddressModal}
                        >
                          <i className="bi bi-eye"></i>
                        </button>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <label className="form-label form-label-modern">
                        Data do Pedido
                      </label>
                      <input
                        type="date"
                        onChange={(e) => setDtPedido(e.target.value)}
                        value={dt_pedido}
                        className="form-control form-control-modern"
                      />
                    </div>
                  </div>
                </div>

                {/* Seção: Configurações do Pedido */}
                <div className="form-section">
                  <h4 className="section-title">
                    <i className="bi bi-gear-fill"></i>
                    Configurações do Pedido
                  </h4>

                  <div className="row g-3">
                    <div className="col-md-3">
                      <label className="form-label form-label-modern">
                        Conta
                      </label>
                      <select
                        className="form-select form-control-modern"
                        value={contaSelecionada}
                        onChange={handleContaChange}
                      >
                        <option value="all">Selecione uma Conta</option>
                        {contas.map((option) => (
                          <option
                            key={option.ID_CONTA}
                            value={option.ID_CONTA}
                          >
                            {option.APELIDO}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label className="form-label form-label-modern">
                        Tipo de Pedido
                      </label>
                      <select
                        className="form-select form-control-modern"
                        value={tipoVenda}
                        onChange={handleTipoVenda}
                      >
                        <option value="all">Selecione o tipo</option>
                        <option value="VENDA">Venda</option>
                        <option value="REPOSICAO">Reposição</option>
                        <option value="CONDICIONAL">Condicional</option>
                        <option value="COMPRA">Compra</option>
                        <option value="TROCA">Troca</option>
                        <option value="AGRUPADO">Agrupado</option>
                        <option value="FILIAL">Filial</option>
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label className="form-label form-label-modern">
                        ID Loja Virtual
                      </label>
                      <input
                        disabled
                        type="text"
                        value={orderID || ''}
                        className="form-control form-control-modern"
                        placeholder="Automático"
                      />
                    </div>

                    <div className="col-md-3">
                      <label className="form-label form-label-modern">
                        Ship ID
                      </label>
                      <div className="input-group input-group-modern">
                        <input
                          type="text"
                          onChange={(e) => setShipID(e.target.value)}
                          value={shipId || ''}
                          className="form-control form-control-modern"
                          onBlur={handleBlur}
                        />
                        <button
                          onClick={handleOpenModalTrack}
                          className="btn btn-outline-secondary"
                        >
                          <img
                            src={kangu}
                            alt="Kangu"
                            style={{
                              width: '20px',
                              height: '20px',
                              zIndex: 999,
                            }}
                          />
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="row g-3 mt-2">
                    <div className="col-md-2">
                      <label className="form-label form-label-modern">
                        Comissão %
                      </label>
                      <input
                        type="text"
                        onChange={(e) =>
                          setComissao(e.target.value.replace(',', '.'))
                        }
                        value={comissao || ''}
                        className="form-control form-control-modern"
                      />
                    </div>

                    <div className="col-md-2">
                      <label className="form-label form-label-modern">
                        RT %
                      </label>
                      <input
                        type="text"
                        min={1}
                        max={100}
                        maxLength="3"
                        onChange={(e) =>
                          setPorcRt(e.target.value.replace(',', '.'))
                        }
                        value={porc_rt || ''}
                        className="form-control form-control-modern"
                      />
                    </div>

                    <div className="col-md-2">
                      <label className="form-label form-label-modern">
                        Prestador %
                      </label>
                      <input
                        type="text"
                        min={1}
                        max={100}
                        maxLength="3"
                        onChange={(e) => setPorcPrestador(e.target.value)}
                        value={porcPrestador}
                        className="form-control form-control-modern"
                      />
                    </div>

                    <div className="col-md-3">
                      <label className="form-label form-label-modern">
                        Forma de Pagamento
                      </label>
                      <select
                        className="form-select form-control-modern"
                        value={id_pagamento}
                        onChange={(e) => setIdPagamento(e.target.value)}
                      >
                        <option value="">Selecione uma forma</option>
                        {formasPagamento.map((forma) => (
                          <option
                            key={forma.cod_forma_pagamento}
                            value={forma.cod_forma_pagamento}
                          >
                            {forma.fpg_descricao}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label className="form-label form-label-modern">
                        Frete
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          onChange={(e) => setFrete(e.target.value)}
                          value={frete.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          })}
                          className="form-control form-control-modern"
                        />
                        <div className="input-group-text">
                          <input
                            className="form-check-input mt-0"
                            type="checkbox"
                            id="calcularFreteCheckbox"
                            checked={cobraFrete}
                            onChange={handleCheckboxChange}
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor="calcularFreteCheckbox"
                          >
                            Calcular
                          </label>
                        </div>
                      </div>
                    </div>

                    {id_pedido !== 'novo' && (
                      <Col md>
                        <CustomButton
                          title="Ver Arquivos"
                          onClick={() => setIsModalAttachmentsOpen(true)}
                        >
                          <Paperclip size={20} />
                        </CustomButton>
                      </Col>
                    )}
                  </div>
                </div>

                {/* Seção: Informações Complementares */}
                <div className="form-section">
                  <h4 className="section-title">
                    <i className="bi bi-info-circle-fill"></i>
                    Informações Complementares
                  </h4>

                  <div className="row g-3">
                    <div className="col-md-2">
                      <label className="form-label form-label-modern">
                        Expedir até
                      </label>
                      <input
                        type="date"
                        onChange={(e) => setDtEntrega(e.target.value)}
                        value={dt_entrega || ''}
                        className="form-control form-control-modern"
                      />
                    </div>

                    <div className="col-md-3">
                      <label className="form-label form-label-modern">
                        Vendedor
                      </label>
                      <select
                        onChange={(e) => setVendedor(e.target.value)}
                        value={vendedor}
                        className="form-select form-control-modern"
                      >
                        <option value="">Selecione um vendedor</option>
                        {vendedores.map((vendedor) => (
                          <option
                            key={vendedor.COD_PESSOA}
                            value={vendedor.COD_PESSOA}
                          >
                            {vendedor.PES_RAZAO}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label className="form-label form-label-modern">
                        Indicador de Venda
                      </label>
                      <select
                        className="form-select form-control-modern"
                        value={indicacaoVenda}
                        onChange={(e) => setIndicacaoVenda(e.target.value)}
                      // style={{ border: '1px solid #ced4da', borderRadius: '6px', padding: '6px' }}
                      >
                        <option value="">Selecione um parceiro</option>
                        {parceiros.map((parceiro) => (
                          <option
                            key={parceiro.COD_PESSOA}
                            value={parceiro.COD_PESSOA}
                          >
                            {parceiro.PES_RAZAO}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label className="form-label form-label-modern">
                        Prestador
                      </label>
                      <select
                        className="form-select form-control-modern"
                        value={prestadorSelecionado}
                        onChange={(e) =>
                          setPrestadorSelecionado(e.target.value)
                        }
                      >
                        <option value="">Selecione um prestador</option>
                        {prestadores.map((prestador) => (
                          <option
                            key={prestador.COD_PESSOA}
                            value={prestador.COD_PESSOA}
                          >
                            {prestador.PES_RAZAO}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-2">
                      <label className="form-label form-label-modern">
                        Desconto
                      </label>
                      <CustomPriceInput
                        onChange={(e) => handleDescontoTotal(e.target.value)}
                        value={desconto}
                        className="form-control form-control-modern"
                      />
                    </div>

                    <div className="col-md-2">
                      <label className="form-label form-label-modern">
                        Outros Valores
                      </label>
                      <input
                        className="form-control form-control-modern text-end"
                        type="text"
                        value={acrescimos}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>

                {/* Seção: Produtos */}
                {id_pedido !== 'novo' ? (
                  <div className="form-section">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h4 className="section-title mb-0">
                        <i className="bi bi-box-seam"></i>
                        Produtos do Pedido
                      </h4>

                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          onClick={alternarModoBusca}
                          className={`btn btn-modern ${estaBuscando ? 'btn-warning-modern' : 'btn-primary-modern'}`}
                        >
                          {estaBuscando ? (
                            <>
                              <i className="bi bi-search"></i>
                              Buscar
                            </>
                          ) : (
                            <>
                              <i className="bi bi-pencil"></i>
                              Manual
                            </>
                          )}
                        </button>

                        <div className="col-md-6 d-flex justify-content-start">
                          {/* BOTÃO PARA IMPORTAR PDF */}
                          <button
                            type="button"
                            className="btn btn-sm btn-success me-2"
                            onClick={() => setShowPDFModal(true)}
                            title="Importar produtos de PDF"
                          >
                            <i className="bi bi-file-pdf"></i> Importar PDF
                          </button>

                          {/* BOTÃO PARA IMPORTAR ORÇAMENTO VIA API */}
                          <button
                            type="button"
                            className="btn btn-sm btn-info me-2"
                            onClick={() => setShowImportModal(true)}
                            disabled={importandoOrcamento}
                            title="Importar orçamento da API"
                          >
                            {importandoOrcamento ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-1"
                                  role="status"
                                ></span>
                                Importando...
                              </>
                            ) : (
                              <>
                                <i className="bi bi-cloud-download"></i>{' '}
                                Importar Orçamento
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <Table
                        className="table table-sm"
                        hover
                        responsive
                      >
                        <thead>
                          <tr>
                            <th
                              style={{ color: '#999999' }}
                              className="text-dark"
                            >
                              Sku
                            </th>
                            <th
                              style={{ color: '#999999' }}
                              className="text-dark"
                            >
                              Produto
                            </th>
                            <th
                              style={{ color: '#999999' }}
                              className="text-dark"
                            >
                              Qtd
                            </th>
                            <th
                              style={{ color: '#999999' }}
                              className="text-dark"
                            >
                              Valor Unit.
                            </th>
                            <th
                              style={{ color: '#999999' }}
                              className="text-dark"
                            >
                              Desconto
                            </th>
                            <th
                              style={{ color: '#999999' }}
                              className="text-dark"
                            >
                              Valor Total
                            </th>
                            <th
                              style={{ color: '#999999' }}
                              className="text-dark"
                            >
                              Obs
                            </th>
                            <th>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {produtos.map((produto, index) => {
                            return (
                              <React.Fragment key={produto.id}>
                                {/* Verifica se é o primeiro item de um novo grupo_item (ambiente) */}
                                {index === 0 ||
                                  produto.grupo_item !==
                                  produtos[index - 1].grupo_item ? (
                                  <tr>
                                    <td
                                      colSpan="10"
                                      className="text-left"
                                      style={{
                                        fontWeight: 'bold',
                                        fontSize: 14,
                                      }}
                                    >
                                      Ambiente:{' '}
                                      {produto?.grupo_item?.toUpperCase()}
                                      <button
                                        type="button"
                                        onClick={() =>
                                          setItemSelecionado(index)
                                        }
                                        className="btn btn-danger btn-sm me-2"
                                        title="Adicionar Grupo"
                                      >
                                        <i className="bi bi-pencil-fill"></i>
                                      </button>
                                    </td>
                                  </tr>
                                ) : null}

                                {/* Linhas dos produtos */}
                                <tr
                                  style={{
                                    backgroundColor:
                                      produto.skuExistente !== null
                                        ? 'inherit'
                                        : 'lightcoral',
                                  }}
                                >
                                  <td
                                    style={{
                                      width: '100px',
                                      backgroundColor:
                                        produto.skuExistente === false
                                          ? 'lightcoral'
                                          : 'inherit',
                                    }}
                                  >
                                    <Form.Control
                                      type="text"
                                      value={produto.codigo}
                                      onChange={console.log}
                                      size="sm"
                                    />
                                  </td>

                                  <td
                                    style={{
                                      width: '650px',
                                      backgroundColor:
                                        produto.skuExistente === false
                                          ? 'lightcoral'
                                          : 'inherit',
                                    }}
                                  >
                                    {estaBuscando ? (
                                      <AutocompleteProdutoMatch
                                        placeholder="Produto banco..."
                                        onClickId={(id) =>
                                          handleProdutoIdChange(id, index)
                                        }
                                        onClickNome={(nome) =>
                                          handleProdutoNomeChange(nome, index)
                                        }
                                        onClickProdInterno={(prodInterno) =>
                                          handleProdutoInternoChange(
                                            prodInterno,
                                            index,
                                          )
                                        }
                                        OnClickValor={(vlr) =>
                                          handleVlUnitChange(vlr, index)
                                        }
                                        OnClickCusto={(vlr) =>
                                          handleCusto(vlr, index)
                                        }
                                        OnClickImg={(img) =>
                                          handleImg(img, index)
                                        }
                                        OnClickComissaoProduto={(vlr) =>
                                          handleComissaoProduto(vlr, index)
                                        }
                                        ClickTexto={handleTextoChange}
                                        value={produto.descricao}
                                        className="form-control"
                                        size="sm"
                                      />
                                    ) : (
                                      <Form.Control
                                        type="text"
                                        placeholder="Inserir manualmente..."
                                        value={produto.descricao}
                                        onChange={(e) =>
                                          handleProdutoNomeChangeInput(
                                            e.target.value,
                                            index,
                                          )
                                        }
                                        size="sm"
                                      />
                                    )}

                                    {!produto.skuExistente && (
                                      <div
                                        style={{
                                          color: 'black',
                                          fontSize: '12px',
                                          marginTop: '5px',
                                        }}
                                      >
                                        SKU não encontrado na base de dados.
                                      </div>
                                    )}
                                  </td>

                                  <td
                                    style={{
                                      backgroundColor:
                                        produto.skuExistente === false
                                          ? 'lightcoral'
                                          : 'inherit',
                                    }}
                                  >
                                    <Form.Control
                                      type="text"
                                      onChange={(e) =>
                                        handleQtdChange(
                                          e.target.value.replace(',', '.'),
                                          index,
                                        )
                                      }
                                      value={
                                        produto.quantidade !== undefined &&
                                          produto.quantidade !== null
                                          ? produto.quantidade
                                            .toString()
                                            .replace('.', '.')
                                          : ''
                                      }
                                      style={{ width: 50 }}
                                      size="sm"
                                    />
                                  </td>

                                  <td
                                    style={{
                                      backgroundColor:
                                        produto.skuExistente === false
                                          ? 'lightcoral'
                                          : 'inherit',
                                    }}
                                  >
                                    <Form.Control
                                      type="text"
                                      onChange={(e) =>
                                        handleVlUnitChange(
                                          e.target.value,
                                          index,
                                        )
                                      }
                                      value={
                                        produto.valorunitario !== undefined &&
                                          produto.valorunitario !== null
                                          ? produto.valorunitario
                                            .toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                            })
                                            .replace(',', '.') // Substitui vírgula por ponto
                                          : 0
                                      }
                                      size="sm"
                                    />
                                  </td>

                                  <td
                                    style={{
                                      backgroundColor:
                                        produto.skuExistente === false
                                          ? 'lightcoral'
                                          : 'inherit',
                                    }}
                                  >
                                    <Form.Control
                                      value={
                                        produto.desconto !== undefined &&
                                          produto.desconto !== null
                                          ? produto.desconto
                                            .toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                            })
                                            .replace(',', '.') // Substitui vírgula por ponto
                                          : 0
                                      }
                                      style={{ width: 100 }}
                                      onChange={(e) =>
                                        handleDescontoChange(
                                          e.target.value.replace(',', '.'),
                                          index,
                                        )
                                      }
                                    />
                                  </td>

                                  <td
                                    style={{
                                      backgroundColor:
                                        produto.skuExistente === false
                                          ? 'lightcoral'
                                          : 'inherit',
                                    }}
                                  >
                                    <CustomPriceInput
                                      disabled
                                      value={produto.valor_total_item}
                                      style={{ width: 130 }}
                                    />
                                  </td>

                                  <td
                                    style={{
                                      backgroundColor:
                                        produto.skuExistente === false
                                          ? 'lightcoral'
                                          : 'inherit',
                                    }}
                                  >
                                    <Form.Control
                                      type="text"
                                      value={produto.obs}
                                      size="sm"
                                      onChange={(e) =>
                                        handleObsChange(e.target.value, index)
                                      }
                                    />
                                  </td>

                                  <td
                                    style={{
                                      backgroundColor:
                                        produto.skuExistente === false
                                          ? 'lightcoral'
                                          : 'inherit',
                                    }}
                                  >
                                    <div className="btn-group">
                                      <OverlayTrigger
                                        overlay={<Tooltip>Excluir</Tooltip>}
                                      >
                                        <CustomButton
                                          isLoading={loading[index]}
                                          isDisabled={
                                            statusPedido === 'Atendido' ||
                                            loading[index]
                                          }
                                          color="#dc3545"
                                          onClick={() => {
                                            if (statusPedido !== 'Atendido') {
                                              ExcluirProduto(produto, index)
                                            }
                                          }}
                                        >
                                          <i className="bi bi-trash3-fill"></i>
                                        </CustomButton>
                                      </OverlayTrigger>
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>
                            )
                          })}
                          {/* Adição do tfoot com os totais */}
                        </tbody>

                        <tfoot
                          style={{
                            background: 'red',
                          }}
                        >
                          <tr>
                            <td
                              colSpan="4"
                              style={{
                                fontWeight: 'bold',
                                fontSize: '12px',
                              }}
                            >
                              Total de Itens:{' '}
                              {produtos.reduce(
                                (total, produto) =>
                                  total + (parseFloat(produto.quantidade) || 0),
                                0,
                              )}
                            </td>
                            <td
                              colSpan="4"
                              // className="text-center"
                              style={{
                                fontWeight: 'bold',
                                fontSize: '12px',
                              }}
                            >
                              Quantidade de Produtos Listados: {produtos.length}
                            </td>
                          </tr>
                        </tfoot>
                      </Table>

                      {produtos.length === 0 && (
                        <div className="text-center py-5 text-muted">
                          <i className="bi bi-box display-1"></i>
                          <p className="mt-3">Nenhum produto cadastrado</p>
                          <p className="small">
                            Clique em "Adicionar" para incluir produtos
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Ações da tabela */}
                    <div className="d-flex justify-content-between align-items-center mt-4">
                      <div className="d-flex gap-2">
                        <button
                          type="button"
                          className="btn btn-sm btn-primary me-2"
                          onClick={AdicionarProduto}
                        >
                          <i className="bi bi-plus-lg"></i> Adicionar
                        </button>

                        <button
                          type="button"
                          className="btn btn-warning-modern btn-modern"
                          onClick={recalcularTodosProdutos}
                        >
                          <i className="bi bi-arrow-repeat"></i>
                          Recalcular
                        </button>

                        <button
                          type="button"
                          className="btn btn-success-modern btn-modern"
                          onClick={exportToExcel}
                        >
                          <i className="bi bi-file-earmark-excel"></i>
                          Exportar
                        </button>
                      </div>

                      <div className="floating-total">
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="h5 mb-0">
                            Total do Pedido:{' '}
                            <span className="h4 mb-0 text-primary fw-bold">
                              {new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              }).format(vl_total - valorDevolvido)}
                            </span>
                          </span>
                        </div>

                        {valorDevolvido > 0 && (
                          <div className="d-flex justify-content-between text-muted">
                            <span>
                              Abatimento:
                              <span
                                style={{
                                  color: 'red',
                                }}
                              >
                                -
                                {new Intl.NumberFormat('pt-BR', {
                                  style: 'currency',
                                  currency: 'BRL',
                                }).format(valorDevolvido)}
                              </span>
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="alert alert-warning alert-modern">
                    <i className="bi bi-exclamation-triangle me-2"></i>É
                    necessário salvar o pedido para incluir produtos!
                  </div>
                )}

                {/* Seção: Observações e Endereço */}
                <div className="form-section">
                  <h4 className="section-title">
                    <i className="bi bi-chat-text"></i>
                    Observações e Entrega
                  </h4>

                  <div className="row g-3">
                    <div className="col-12">
                      <label className="form-label form-label-modern">
                        Observações
                      </label>
                      <textarea
                        onChange={(e) => setDetalhesPedido(e.target.value)}
                        value={detalhesPedido}
                        className="form-control form-control-modern"
                        rows="3"
                        placeholder="Digite as observações do pedido..."
                      />
                    </div>

                    <div className="col-12">
                      <label className="form-label form-label-modern">
                        Endereço de Entrega
                      </label>
                      <textarea
                        onChange={(e) => setEndEnt(e.target.value)}
                        value={endEnt}
                        className="form-control form-control-modern"
                        rows="3"
                        placeholder="Digite o endereço de entrega..."
                      />
                    </div>
                  </div>
                </div>

                {/* Seção: Parcelas */}
                <div className="form-section">
                  <h4 className="section-title">
                    <i className="bi bi-credit-card"></i>
                    Parcelas e Pagamento
                  </h4>

                  <div className="row g-3 mb-4">
                    <div className="col-auto">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipoDuplicatas"
                          id="tipoDias"
                          checked={tipoDuplicatas === 'dias'}
                          onChange={() => setTipoDuplicatas('dias')}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="tipoDias"
                        >
                          Por Dias
                        </label>
                      </div>
                    </div>

                    <div className="col-auto">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="tipoDuplicatas"
                          id="tipoParcelas"
                          checked={tipoDuplicatas === 'parcelas'}
                          onChange={() => setTipoDuplicatas('parcelas')}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="tipoParcelas"
                        >
                          Por Parcelas
                        </label>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <label className="form-label form-label-modern">
                        A partir da data
                      </label>
                      <CustomInputDate
                        selected={fromDate}
                        onChange={setFromDate}
                        className="form-control form-control-modern"
                      />
                    </div>
                  </div>

                  {tipoDuplicatas === 'dias' ? (
                    <div className="row g-3 mb-4">
                      <div className="col-md-8">
                        <label className="form-label form-label-modern">
                          Dias para as Parcelas (separados por vírgula)
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control form-control-modern"
                            value={diasParcelas}
                            onChange={(e) => setDiasParcelas(e.target.value)}
                            placeholder="Ex: 30, 60, 90"
                          />
                          <button
                            className="btn btn-primary-modern btn-modern"
                            type="button"
                            onClick={calcularParcelas}
                          >
                            <i className="bi bi-calculator"></i>
                            Calcular
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row g-3 mb-4">
                      <div className="col-md-3">
                        <label className="form-label form-label-modern">
                          Quantidade de Parcelas
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-modern"
                          value={quantidadeParcelas}
                          onChange={(e) =>
                            setQuantidadeParcelas(e.target.value)
                          }
                          placeholder="Ex: 10"
                        />
                      </div>

                      <div className="col-md-3">
                        <label className="form-label form-label-modern">
                          Dia do Mês
                        </label>
                        <input
                          type="number"
                          className="form-control form-control-modern"
                          value={diaDoMes}
                          onChange={(e) => setDiaDoMes(e.target.value)}
                          placeholder="Ex: 15"
                          min="1"
                          max="31"
                        />
                      </div>

                      <div className="col-md-3 d-flex align-items-end">
                        <button
                          className="btn btn-primary-modern btn-modern"
                          onClick={gerarParcelas}
                          disabled={!vl_total}
                        >
                          <i className="bi bi-file-plus"></i>
                          Gerar Parcelas
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Tabela de Parcelas */}
                  <div className="mt-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5>Parcelas Geradas</h5>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="recalcularParcelas"
                          checked={recalculateParcels}
                          onChange={(e) =>
                            setRecalculateParcels(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="recalcularParcelas"
                        >
                          Recalcular automaticamente
                        </label>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="table table-modern">
                        <thead>
                          <tr>
                            <th>Parcela</th>
                            <th>Vencimento</th>
                            <th>Valor</th>
                            <th>Anotações</th>
                            <th>Linha Digitável</th>
                            <th>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {resultado.map((parcela, index) => (
                            <tr key={parcela.codigo || parcela.numero || index}>
                              <td className="fw-bold">
                                <span className="badge bg-primary">
                                  {String(parcela.numero).padStart(3, '0')}
                                </span>
                              </td>
                              <td>
                                <input
                                  type="date"
                                  className="form-control form-control-sm"
                                  value={parcela.datavencimento || ''}
                                  onChange={(e) =>
                                    handleChangeDataVencimento(e.target.value, index)
                                  }
                                />
                              </td>
                              <td>
                                <CustomPriceInput
                                  value={parcela.valor}
                                  onChange={(e) =>
                                    handleEditarValor(parcela.numero, e.target.value)
                                  }
                                  disabled={!isEditMode[index]}
                                  style={{ width: '120px' }}
                                  onBlur={() => recalcularParcelas(index)}
                                  size="sm"
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  value={parcela.obs || ''}
                                  onChange={(e) =>
                                    handleEditarObservacao(parcela.numero, e.target.value)
                                  }
                                  className="form-control form-control-sm"
                                  placeholder="Observações..."
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  value={parcela.linhadigitavel || ''}
                                  disabled
                                  className="form-control form-control-sm"
                                  style={{ fontSize: '11px' }}
                                />
                              </td>
                              <td>
                                <div className="d-flex gap-1">
                                  <button
                                    className={`btn btn-sm ${!isEditMode[index] ? 'btn-warning' : 'btn-success'}`}
                                    onClick={() => {
                                      setIsEditMode((prevState) => ({
                                        ...prevState,
                                        [index]: !prevState[index],
                                      }))
                                    }}
                                    title={!isEditMode[index] ? 'Editar' : 'Salvar'}
                                  >
                                    <i className={`bi ${!isEditMode[index] ? 'bi-pencil' : 'bi-check-circle'}`}></i>
                                  </button>

                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleExcluirParcela(index)}
                                    disabled={!!parcela.linhadigitavel}
                                    title="Deletar"
                                  >
                                    <i className="bi bi-trash3"></i>
                                  </button>

                                  <button
                                    className="btn btn-success btn-sm"
                                    onClick={() => handleGerarBoleto(parcela.codigo, index)}
                                    disabled={isLoadingB[index] || !!parcela.linhadigitavel}
                                    title="Gerar Boleto"
                                  >
                                    {isLoadingB[index]
                                      ? <i className="bi bi-arrow-repeat"></i>
                                      : <i className="bi bi-file-earmark-text"></i>}
                                  </button>

                                  <button
                                    className="btn btn-info btn-sm"
                                    onClick={() => handleImprimirBoleto(parcela.linhadigitavel, index)}
                                    disabled={isLoadingB[index] || !parcela.linhadigitavel}
                                    title="Imprimir Boleto"
                                  >
                                    <i className="bi bi-printer"></i>
                                  </button>

                                  <button
                                    className="btn btn-sm"
                                    style={{ backgroundColor: '#25D366', color: 'white' }}
                                    onClick={() => handleEnviarBoleto(parcela.linhadigitavel, index)}
                                    disabled={isLoadingB[index] || !parcela.linhadigitavel}
                                    title="Enviar via WhatsApp"
                                  >
                                    <i className="bi bi-whatsapp"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {resultado.length === 0 && (
                        <div className="text-center py-4 text-muted">
                          <i className="bi bi-credit-card display-1"></i>
                          <p className="mt-3">Nenhuma parcela gerada</p>
                          <p className="small">
                            Configure as parcelas usando as opções acima
                          </p>
                        </div>
                      )}
                    </div>

                    <div className="mt-3">
                      <button
                        className="btn btn-danger-modern btn-modern"
                        disabled={resultado.length === 0 || !id_pagamento}
                        onClick={HandleLanc}
                      >
                        <i className="bi bi-file-earmark-check"></i>
                        Lançar Contas
                      </button>
                    </div>
                  </div>
                </div>

                {/* Seção: Ações do Pedido */}
                <div
                  className="form-section"
                  style={{
                    width: '95%',
                    margin: '10px auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <div className="row g-3">
                    <div className="col-12">
                      {msg.length > 0 && (
                        <div className="alert alert-danger alert-modern">
                          <i className="bi bi-exclamation-triangle me-2"></i>
                          {msg}
                        </div>
                      )}

                      <div className="d-flex flex-wrap gap-2 justify-content-end">
                        <button
                          type="button"
                          className={`btn btn-warning-modern btn-modern ${isLoading ? 'disabled' : ''}`}
                          onClick={isLoading ? null : HandleEstoque}
                        >
                          {isLoading ? (
                            <>
                              <i className="bi bi-arrow-repeat"></i>
                              Processando...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-box-arrow-down"></i>
                              Ajuste de Estoque
                            </>
                          )}
                        </button>

                        <button
                          type="button"
                          className={`btn btn-warning-modern btn-modern ${isLoading ? 'disabled' : ''}`}
                          onClick={isLoading ? null : HandleCreateNFE}
                        >
                          {isLoading ? (
                            <>
                              <i className="bi bi-arrow-repeat"></i>
                              Processando...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-file-earmark-text"></i>
                              Criar NFE
                            </>
                          )}
                        </button>

                        <button
                          type="button"
                          className="btn btn-success-modern btn-modern"
                          onClick={SalvarDados}
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <>
                              <i className="bi bi-arrow-repeat"></i>
                              Salvando...
                            </>
                          ) : (
                            <>
                              <i className="bi bi-check-circle"></i>
                              Salvar Pedido
                            </>
                          )}
                        </button>

                        <button
                          type="button"
                          className="btn btn-danger-modern btn-modern"
                          onClick={() => ImpPdf('Completo')}
                        >
                          <i className="bi bi-file-pdf"></i>
                          Imprimir PDF
                        </button>

                        <button
                          type="button"
                          className="btn btn-danger-modern btn-modern"
                          onClick={() => ImpPdf('Resumo')}
                        >
                          <i className="bi bi-file-pdf"></i>
                          Espelho
                        </button>

                        {localStorage.idconta === '111111111' && (
                          <button
                            className="btn btn-primary-modern btn-modern"
                            onClick={() =>
                              handleExportOrderToBHDatabase(id_pedido)
                            }
                            disabled={
                              isExportOrderLoading || produtos.length === 0
                            }
                          >
                            {isExportOrderLoading ? (
                              <>
                                <i className="bi bi-arrow-repeat"></i>
                                Exportando...
                              </>
                            ) : (
                              <>
                                <i className="bi bi-share"></i>
                                Exportar Matriz
                              </>
                            )}
                          </button>
                        )}



                        <button
                          type="button"
                          className="btn btn-warning-modern btn-modern"
                          onClick={() => navigate(`/caixa/diario?pedido=${id_pedido}`)}
                        >
                          <i className="bi bi-cash-register"></i>
                          Pedido PDV
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                position: 'fixed',
                bottom: 0,
                right: 0,
                margin: 10,
              }}
            >
              <CaretCircleUp
                onClick={scrollToTop}
                size={50}
                color="#007bff"
                weight="fill"
                style={{
                  cursor: 'pointer',
                  zIndex: 9999,
                }}
              />

              <CaretCircleDown
                onClick={scrollToBottom}
                size={50}
                color="#007bff"
                weight="fill"
                style={{
                  cursor: 'pointer',
                  zIndex: 9999,
                }}
              />
            </div>
          </div>

          {/* Todos os modais permanecem iguais, mas com classes CSS atualizadas */}
          <Modal show={isModalOpen} onHide={handleModalClose} className="modal-modern" size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                <i className="bi bi-cash-register me-2"></i>
                Totalizar Pagamento — Pedido #{id_pedido}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>

              {/* BLOCO: Status do Caixa */}
              {loadingCaixa ? (
                <div className="text-center py-3">
                  <div className="spinner-border spinner-border-sm text-primary me-2" />
                  Verificando pagamentos anteriores...
                </div>
              ) : dadosCaixa ? (
                <div className={`alert ${dadosCaixa.caixa_batendo ? 'alert-success' : 'alert-warning'} mb-3`}>
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div>
                      <strong>
                        {dadosCaixa.caixa_batendo
                          ? '✅ Pedido Quitado'
                          : '⚠️ Pagamento Parcial'}
                      </strong>
                      <div style={{ fontSize: 13 }} className="mt-1">
                        <span className="me-3">
                          Total: <strong>R$ {dadosCaixa.valor_total?.toFixed(2)}</strong>
                        </span>
                        <span className="me-3">
                          Recebido: <strong>R$ {dadosCaixa.total_recebido?.toFixed(2)}</strong>
                        </span>
                        {dadosCaixa.total_troco > 0 && (
                          <span className="me-3">
                            Troco dado: <strong>R$ {dadosCaixa.total_troco?.toFixed(2)}</strong>
                          </span>
                        )}
                        <span>
                          Restante:{' '}
                          <strong className={dadosCaixa.saldo_restante > 0 ? 'text-danger' : 'text-success'}>
                            R$ {dadosCaixa.saldo_restante?.toFixed(2)}
                          </strong>
                        </span>
                      </div>
                    </div>
                    <span className={`badge ${dadosCaixa.caixa_batendo ? 'bg-success' : 'bg-warning text-dark'}`}>
                      {dadosCaixa.status}
                    </span>
                  </div>

                  {/* Histórico de pagamentos anteriores */}
                  {dadosCaixa.historico?.length > 0 && (
                    <div className="mt-3">
                      <strong style={{ fontSize: 13 }}>Histórico de recebimentos:</strong>
                      <table className="table table-sm table-bordered mt-2 mb-0" style={{ fontSize: 12 }}>
                        <thead className="table-light">
                          <tr>
                            <th>Data</th>
                            <th>Forma</th>
                            <th>Recebido</th>
                            <th>Troco</th>
                            <th>Usuário</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dadosCaixa.historico.map((h, i) => (
                            <tr key={i}>
                              <td>{h.data ? new Date(h.data).toLocaleString('pt-BR') : '-'}</td>
                              <td>{h.forma_pgto}</td>
                              <td className="text-success fw-bold">R$ {parseFloat(h.vlr_recebido).toFixed(2)}</td>
                              <td>{h.troco > 0 ? `R$ ${parseFloat(h.troco).toFixed(2)}` : '-'}</td>
                              <td>{h.usuario || '-'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              ) : null}

              {/* BLOCO: Novo pagamento — só mostra se ainda tem saldo */}
              {!dadosCaixa?.caixa_batendo && (
                <>
                  {/* Dentro do bloco {!dadosCaixa?.caixa_batendo && ( */}
                  {/* Adicionar ANTES do Form.Group do caixa: */}

                  {parseFloat(valorDevolvido) > 0 && (
                    <div className="alert alert-info d-flex align-items-center gap-2 mb-3" style={{ fontSize: 13 }}>
                      <i className="bi bi-arrow-down-circle-fill text-info" style={{ fontSize: 18 }}></i>
                      <div>
                        <strong>Abatimento aplicado neste pedido:</strong>{' '}
                        <span className="text-danger fw-bold">
                          - R$ {parseFloat(valorDevolvido).toFixed(2)}
                        </span>
                        <div className="text-muted" style={{ fontSize: 12 }}>
                          Valor original: R$ {parseFloat(vl_total).toFixed(2)} →
                          Valor a pagar: R$ {(parseFloat(vl_total) - parseFloat(valorDevolvido)).toFixed(2)}
                        </div>
                      </div>
                    </div>
                  )}
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-modern">Número do Caixa</Form.Label>
                    <Form.Select
                      className="form-control-modern"
                      value={idCaixaSelecionado}
                      onChange={(e) => setIdCaixaSelecionado(e.target.value)}
                    >
                      <option value="">Selecione o caixa...</option>
                      {caixasAbertos.map((caixa) => (
                        <option key={caixa.id_cx} value={caixa.id_cx}>
                          Caixa Nº {caixa.id_cx} - Fundo: R$ {caixa.fundo_caixa}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-modern">Forma de Pagamento</Form.Label>
                    <Form.Select
                      className="form-control-modern"
                      value={formaPagamento}
                      onChange={(e) => { setFormaPagamento(e.target.value); setTroco(0) }}
                    >
                      <option value="">Selecione...</option>
                      <option value="Dinheiro">Dinheiro</option>
                      <option value="Cartão">Cartão</option>
                      <option value="Pix">Pix</option>
                      <option value="Boleto">Boleto</option>
                      <option value="Cheque">Cheque</option>
                      <option value="Devolucao">Devolução</option>
                      <option value="Haver">Haver</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-modern">Valor Recebido</Form.Label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control form-control-modern"
                        placeholder="Informe o valor recebido"
                        value={valorRecebido}
                        onChange={handleValorRecebidoChange}
                      />
                      <button
                        className="btn btn-primary-modern"
                        onClick={handleAdicionarPagamento}
                        disabled={!formaPagamento || !valorRecebido || !idCaixaSelecionado}
                      >
                        <i className="bi bi-plus"></i> Adicionar
                      </button>
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-modern">Troco</Form.Label>
                    <input
                      disabled
                      type="text"
                      className="form-control form-control-modern"
                      value={troco?.toFixed(2)}
                      readOnly
                    />
                  </Form.Group>

                  {/* Pagamentos adicionados nesta sessão */}
                  {pagamentos.length > 0 && (
                    <div className="table-responsive">
                      <table className="table table-modern">
                        <thead>
                          <tr>
                            <th>Forma</th>
                            <th>Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pagamentos.map((pagamento, index) => (
                            <tr key={index}>
                              <td>{pagamento.forma}</td>
                              <td>R$ {pagamento.valor.toFixed(2)}</td>
                            </tr>
                          ))}
                          <tr className="table-primary">
                            <td><strong>Saldo Restante</strong></td>
                            <td><strong className="text-danger">R$ {saldoPendente.toFixed(2)}</strong></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              )}

            </Modal.Body>

            <Modal.Footer>
              <button className="btn btn-secondary" onClick={handleModalClose}>
                Cancelar
              </button>
              {/* Só mostra o botão de confirmar se há pagamentos novos para lançar */}
              {pagamentos.length > 0 && (
                <button
                  className="btn btn-primary-modern btn-modern"
                  onClick={handleFinalizarPagamento}
                  disabled={isFinalizandoPagamento} // 🔒 desabilita visualmente
                >
                  {isFinalizandoPagamento ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" />
                      Processando...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-check-circle"></i>
                      Confirmar e Lançar no Caixa
                    </>
                  )}
                </button>
              )}
            </Modal.Footer>
          </Modal>




          <Modal
            show={isModalFileOpen}
            onShow={() => setNovosArquivosPedido([])}
            onHide={() => setIsModalFileOpen(false)}
            dialogClassName="custom-modalzpl"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Inserir Arquivos</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Alert variant="info">Apenas arquivos PDF são permitidos.</Alert>

              <Form.Control
                className="fileInput"
                accept=".pdf"
                type="file"
                onChange={handleSelectFiles}
                multiple
              />

              {novosArquivosPedido.map((arquivo, index) => (
                <>
                  <hr />

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: 10,
                      marginTop: 20,
                    }}
                  >
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 10,
                      }}
                    >
                      <p
                        style={{
                          all: 'unset',
                          fontWeight: 'bold',
                        }}
                      >
                        {arquivo.file.name.length > 30
                          ? arquivo.file.name.substring(0, 29).concat('...')
                          : arquivo.file.name}
                      </p>

                      <CustomButton
                        isDelete
                        noMargin
                        onClick={() =>
                          setNovosArquivosPedido((prevState) =>
                            prevState.filter((a) => a.id !== arquivo.id),
                          )
                        }
                      >
                        <TrashFill />
                      </CustomButton>
                    </div>

                    <Form.Control
                      type="text"
                      value={arquivo.descricao}
                      placeholder="Descrição"
                      onChange={(e) => {
                        setNovosArquivosPedido((prevState) =>
                          prevState.with(index, {
                            ...prevState[index],
                            descricao: e.target.value,
                          }),
                        )
                      }}
                    />
                  </div>
                </>
              ))}
            </Modal.Body>

            <Modal.Footer>
              <CustomButton
                color="#229954"
                title="Salvar"
                isLoadingText="Salvando..."
                isLoading={isOrderFileLoading}
                onClick={handleSaveOrderFile}
                disabled={
                  novosArquivosPedido.length === 0 ||
                  novosArquivosPedido.some(
                    (arquivo) => !arquivo.file || !arquivo.descricao,
                  )
                }
              />

              <CustomButton
                color="#6c757d"
                title="Fechar"
                onClick={() => setIsModalFileOpen(false)}
              />
            </Modal.Footer>
          </Modal>

          <Modal
            show={showAddressModal}
            onHide={handleCloseAddressModal}
            dialogClassName="custom-modalzpl"
          >
            <form onSubmit={HandleCadastrarCliente}>
              <Modal.Header closeButton>
                <Modal.Title>Dados do Cliente</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <Row className="mb-3">
                  <Col xs={2}>
                    <Form.Label> Tipo de Cadastro:</Form.Label>

                    <Form.Select
                      value={endereco.pes_tipo || 'F'}
                      onChange={handleTipoCadastroChange}
                    >
                      <option value="F">Pessoa Física</option>
                      <option value="J">Pessoa Jurídica</option>
                    </Form.Select>
                  </Col>

                  <Col xs={3}>
                    <Form.Label> Contribuinte:</Form.Label>

                    <Form.Select
                      value={endereco.cod_tipo_contribuinte}
                      onChange={handleTipoContribuinte}
                    >
                      <option value="1">CONTRIBUINTE ICMS</option>
                      <option value="2">CONTRIBUINTE ISENTO</option>
                      <option value="9">NAO CONTRIBUINTE</option>
                      <option value="99">NAO SELECIONADO</option>
                    </Form.Select>
                  </Col>

                  <Col>
                    <Form.Label>
                      {endereco.pes_tipo === 'F' ? 'Nome' : 'Nome da Empresa'}
                    </Form.Label>

                    <Form.Control
                      value={endereco.pes_razao}
                      onChange={handleNomeChange}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col>
                    <Form.Label>
                      {endereco.pes_tipo === 'F' ? 'CPF' : 'CNPJ'}
                    </Form.Label>

                    <ReactInputMask
                      mask={
                        endereco.pes_tipo === 'F'
                          ? '999.999.999-99'
                          : '99.999.999/9999-99'
                      }
                      maskChar={null}
                      value={endereco.pes_cnpj_cpf}
                      onChange={handleCpfCnpjChange}
                      className="form-control"
                    />
                  </Col>

                  <Col>
                    <Form.Label>
                      {endereco.pes_tipo === 'F' ? 'RG' : 'Insc. Estadual'}:
                    </Form.Label>

                    <Form.Control
                      value={endereco.pes_insc_estadual}
                      onChange={handleRGIEChange}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: 5,
                      }}
                    >
                      <Form.Label className="form-label">CEP:</Form.Label>

                      {isLoadingCep && <CustomSpinner size={20} />}
                    </div>

                    <Form.Control
                      value={endereco.pes_cep}
                      onChange={handleCepChange}
                      onBlur={buscaCep}
                      disabled={isLoadingCep}
                      placeholder={isLoadingCep && 'Buscando...'}
                    />
                  </Col>

                  <Col>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: 5,
                      }}
                    >
                      <Form.Label className="form-label">Rua:</Form.Label>

                      {isLoadingCep && <CustomSpinner size={20} />}
                    </div>

                    <Form.Control
                      value={endereco.pes_logradouro}
                      onChange={handleRuaChange}
                      disabled={isLoadingCep}
                      placeholder={isLoadingCep && 'Buscando...'}
                    />
                  </Col>

                  <Col>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: 5,
                      }}
                    >
                      <Form.Label className="form-label">Bairro:</Form.Label>

                      {isLoadingCep && <CustomSpinner size={20} />}
                    </div>

                    <Form.Control
                      value={endereco.pes_bairro}
                      onChange={handleBairroChange}
                      disabled={isLoadingCep}
                      placeholder={isLoadingCep && 'Buscando...'}
                    />
                  </Col>

                  <Col>
                    <Form.Label>Número</Form.Label>

                    <Form.Control
                      value={endereco.pes_numero}
                      onChange={handleNumeroChange}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: 5,
                      }}
                    >
                      <Form.Label className="form-label">Cidade:</Form.Label>

                      {isLoadingCep && <CustomSpinner size={20} />}
                    </div>

                    <Form.Control
                      value={endereco.pes_cidade}
                      onChange={handleCidadeChange}
                      disabled={isLoadingCep}
                      placeholder={isLoadingCep && 'Buscando...'}
                    />
                  </Col>

                  <Col>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: 5,
                      }}
                    >
                      <Form.Label className="form-label">Estado:</Form.Label>

                      {isLoadingCep && <CustomSpinner size={20} />}
                    </div>

                    <Form.Control
                      value={endereco.pes_uf}
                      onChange={handleEstadoChange}
                      disabled={isLoadingCep}
                      placeholder={isLoadingCep && 'Buscando...'}
                    />
                  </Col>

                  <Col>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        gap: 5,
                      }}
                    >
                      <Form.Label className="form-label">IBGE:</Form.Label>

                      {isLoadingCep && <CustomSpinner size={20} />}
                    </div>

                    <Form.Control
                      value={endereco.pes_ibge}
                      onChange={handlePesIbge}
                      disabled={isLoadingCep}
                      placeholder={isLoadingCep && 'Buscando...'}
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col>
                    <Form.Label>Telefone</Form.Label>

                    <Form.Control
                      value={endereco.pes_telefone}
                      onChange={handleTelefoneChange}
                    />
                  </Col>

                  <Col>
                    <Form.Label>Celular</Form.Label>

                    <InputMask
                      mask="(99) 99999-9999"
                      maskChar={null}
                      className="form-control"
                      id="celular"
                      value={endereco.pes_celular}
                      onChange={handleCelularChange}
                    />
                  </Col>
                </Row>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="success"
                  type="submit"
                >
                  Cadastrar Cliente
                </Button>

                <Button
                  variant="secondary"
                  onClick={handleCloseAddressModal}
                >
                  Fechar
                </Button>
              </Modal.Footer>
            </form>
          </Modal>

          <Modal
            show={itemSelecionado !== null}
            onHide={() => setItemSelecionado(null)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Informações do Grupo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {itemSelecionado !== null && (
                <div>
                  <p>Grupo: {produtos[itemSelecionado].grupo}</p>
                  {/* Outras informações do grupo */}
                  <Form.Control
                    type="text"
                    value={inputValue}
                    onChange={handleInputChange}
                    placeholder="Digite algo..."
                  />
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={handleInserir}
                variant="primary"
              >
                Inserir
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showModal}
            onHide={handleCloseModal}
          >
            <Modal.Header closeButton>
              <Modal.Title>NFE Criada com Sucesso!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                A NFE foi criada com sucesso. Clique no link abaixo para
                visualizá-la:
              </p>
              <a
                href={`/nfe/editar/${idNFe}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Visualizar NFE
              </a>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={handleCloseModal}
              >
                Fechar
              </Button>
            </Modal.Footer>
          </Modal>

          {showModalEst && (
            <Modal
              show={showModalEst}
              onHide={handleCloseModalEst}
              dialogClassName="custom-modalzpl"
            >
              <Modal.Header closeButton>
                <Modal.Title>Realizar baixa de estoque</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p style={{ color: '#c0c0c0', fontSize: '12px' }}>
                  Selecione os itens para baixa.
                </p>
                <Table
                  striped
                  bordered
                  hover
                  style={{ fontSize: '12px' }}
                >
                  <thead>
                    <tr>
                      <th>
                        <Form.Check
                          checked={
                            produtosEstoque.length > 0 &&
                            produtosEstoque.every(
                              (produto) =>
                                quantidadesSelecionadas.findIndex(
                                  (product) => product.sku == produto.sku,
                                ) !== -1,
                            )
                          }
                          disabled={produtosEstoque.length === 0}
                          onChange={(e) => {
                            if (e.target.checked) {
                              for (const produto of produtosEstoque) {
                                setQuantidadesSelecionadas((prevState) => {
                                  const index = prevState.findIndex(
                                    (product) => product.sku == produto.sku,
                                  )

                                  if (index === -1 && produto.lancado !== 'S') {
                                    return [...prevState, produto]
                                  }

                                  return prevState
                                })
                              }
                            } else {
                              setQuantidadesSelecionadas([])
                            }
                          }}
                        />
                      </th>
                      <th>SKU</th>
                      <th>Descrição</th>
                      <th>Quantidade</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {produtosEstoque.map((produto) => (
                      <tr key={produto.sku}>
                        <td>
                          <Form.Check
                            type="checkbox"
                            checked={
                              quantidadesSelecionadas.findIndex(
                                (product) => product.sku == produto.sku,
                              ) === -1
                                ? false
                                : true
                            }
                            onChange={() => handleCheckboxChangeEst(produto)}
                            disabled={produto.lancado === 'S'}
                          />
                        </td>

                        <td>{produto.sku}</td>
                        <td>{produto.descricao}</td>
                        <td>{produto?.quantidade}</td>
                        <td>
                          <OverlayTrigger
                            overlay={
                              <Tooltip>
                                {produto?.lancado
                                  ? 'Estoque Lançado'
                                  : 'Estoque Não Lançado'}
                              </Tooltip>
                            }
                          >
                            {produto?.lancado ? (
                              <CheckCircleFill
                                color="green"
                                size={20}
                              />
                            ) : (
                              <XCircleFill
                                color="red"
                                size={20}
                              />
                            )}
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  onClick={handleBaixarEstoque}
                >
                  {isLoading ? (
                    <>
                      <FontAwesomeIcon
                        icon={faSpinner}
                        spin
                        className="me-2"
                      />
                      Processando...
                    </>
                  ) : (
                    'Realizar Baixa de Estoque'
                  )}
                </Button>

                <Button
                  variant="secondary"
                  onClick={handleCloseModalEst}
                >
                  Fechar
                </Button>
              </Modal.Footer>
            </Modal>
          )}

          {showWarningModal && (
            <Modal
              show={showWarningModal}
              onHide={() => setShowWarningModal(false)}
              size="lg"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Atenção: Confirmação Necessária</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h2>Você já salvou o pedido?</h2>
                <p>
                  Antes de gerar o boleto, é obrigatório que você salve o
                  pedido. Isso garante que o sistema capture o ID da parcela
                  corretamente. Por favor, verifique se o pedido já foi salvo
                  para evitar erros no processo de geração do boleto.
                </p>
                <p>
                  Se o pedido não foi salvo, clique em "Cancelar" e salve o
                  pedido antes de prosseguir. Caso contrário, você poderá
                  continuar.
                </p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowWarningModal(false)}
                >
                  Cancelar
                </Button>
                <Button
                  variant="primary"
                  onClick={() => handleProceedWithBoleto()}
                >
                  Continuar e gerar boleto
                </Button>
              </Modal.Footer>
            </Modal>
          )}

          {modalOpen && (
            <TrackModal
              open={modalOpen}
              onClose={handleCloseModalTrack}
              trackData={trackData}
            />
          )}
        </div>
      )}

      <PDFExtractorModal
        show={showPDFModal}
        onHide={() => setShowPDFModal(false)}
        onProductsExtracted={handleProductsFromPDF}
      />

      {isModalAttachmentsOpen && (
        <Modal
          show={isModalAttachmentsOpen}
          onShow={loadAttachments}
          onHide={() => setIsModalAttachmentsOpen(false)}
          dialogClassName="custom-modalzpl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Arquivos</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <ContentLoading
              isLoading={isAttachmentsLoading}
              loadingText="Carregando..."
            >
              <div
                style={{
                  display: 'flex',
                  gap: 10,
                }}
              >
                <CustomButton
                  title="Inserir Arquivos"
                  onClick={() => {
                    setIsModalAttachmentsOpen(false)
                    setIsModalFileOpen(true)
                  }}
                  noMargin
                >
                  <PlusCircleFill size={18} />
                </CustomButton>

                <CustomButton
                  isDelete
                  title="Excluir Todos"
                  onClick={() =>
                    Ask('Excluir TODOS os arquivos?', () => handleDeleteFiles())
                  }
                  noMargin
                  isLoading={isLoadingDeleteAllAttachments}
                  isLoadingText="Excluindo..."
                >
                  <TrashFill size={18} />
                </CustomButton>
              </div>

              <div>
                {attachments.length > 0 ? (
                  <Table>
                    <thead>
                      <tr>
                        <td>Descrição</td>
                        <td>Arquivo</td>
                        <td>Ação</td>
                      </tr>
                    </thead>

                    <tbody>
                      {attachments.map((arquivo, index) => (
                        <tr>
                          <td>{arquivo.descricao}</td>

                          <td>{arquivo.nome_arquivo}</td>

                          <td>
                            <div
                              style={{
                                display: 'flex',
                              }}
                            >
                              <OverlayTrigger
                                overlay={<Tooltip>Baixar Arquivo</Tooltip>}
                              >
                                <a
                                  target="_blank"
                                  href={`${process.env.REACT_APP_BACKEND_API}/order-files/download/${arquivo.nome_arquivo}`}
                                  rel="noreferrer"
                                >
                                  <CustomButton color="#229954">
                                    <CloudArrowDownFill size={18} />
                                  </CustomButton>
                                </a>
                              </OverlayTrigger>

                              <OverlayTrigger
                                overlay={<Tooltip>Excluir</Tooltip>}
                              >
                                <CustomButton
                                  color="#d30f0f"
                                  isLoading={isLoadingDeleteAttachment[index]}
                                  onClick={() =>
                                    Ask('Deseja excluir o arquivo?', () =>
                                      handleDeleteFile(arquivo.id, index),
                                    )
                                  }
                                >
                                  <TrashFill size={18} />
                                </CustomButton>
                              </OverlayTrigger>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <p className="mt-3">Sem arquivos.</p>
                )}
              </div>
            </ContentLoading>
          </Modal.Body>
        </Modal>
      )}

      {showImportModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="bi bi-cloud-download me-2"></i>
                  Importar Orçamento
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowImportModal(false)
                    setOrcamentoIdInput('')
                  }}
                ></button>
              </div>

              <div className="modal-body">
                <div className="mb-3">
                  <label
                    htmlFor="orcamentoId"
                    className="form-label"
                  >
                    ID/Número do Orçamento
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="orcamentoId"
                    value={orcamentoIdInput}
                    onChange={(e) => setOrcamentoIdInput(e.target.value)}
                    placeholder="Ex: ORC-2024-001 ou 123"
                    autoFocus
                  />
                  <div className="form-text">
                    Digite o ID ou número do orçamento que deseja importar
                  </div>
                </div>

                <div className="alert alert-info">
                  <i className="bi bi-info-circle me-2"></i>
                  <strong>Atenção:</strong> Os produtos importados serão
                  adicionados ao orçamento atual. Você poderá escolher se deseja
                  substituir ou manter os produtos existentes.
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowImportModal(false)
                    setOrcamentoIdInput('')
                  }}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleImportFromModalAPI}
                  disabled={!orcamentoIdInput.trim() || importandoOrcamento}
                >
                  {importandoOrcamento ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Importando...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-download me-2"></i>
                      Importar
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
export default PedidoMK
